export default {
    fund: [{
            "title": "关于证券投资基金，以下表述错误的是（　　）。",
            "question": "A. 证券投资基金需要进行及时、准确、充分的信息披露\nB. 监管机构对证券投资基金行业实行严格的监管\nC. 基金管理人需要定期披露投资业绩、重点投资品种和未来投资回报预测\nD. 管理人和托管人相互制约、相互监督是证券投资基金监管的重要环节",
            "answer": "C",
            "explain": "基金宣传禁止对未来的投资收益进行预测。"
        },
        {
            "title": "（　　）既是基金合同的当事人，又是基金的主要服务机构。",
            "question": "A. 基金投资顾问机构和基金销售机构\nB. 基金管理人和基金托管人\nC. 基金份额登记机构和基金销售机构\nD. 基金投资人和基金托管人",
            "answer": "B",
            "explain": "我国的证券投资基金依据基金合同设立，基金份额持有人、基金管理人与基金托管人是基金合同的当事人，简称基金当事人。其中，基金管理人和基金托管人既是基金的当事人，又是基金的主要服务机构。"
        },
        {
            "title": "下列关于独立董事任职资格的说法，不正确的是（　　）。",
            "question": "A. 有履行职责所需要的时间\nB. 具有3年以上金融、法律或者财务的工作经历\nC. 直系亲属不在拟任职的基金管理公司任职\nD. 最近3年没有受到证券、银行、工商和税务等行政管理部门的行政处罚",
            "answer": "B",
            "explain": "独立董事任职资格的条件之一是具有5年以上金融、法律或者财务的工作经历。"
        },
        {
            "title": "根据基金业协会发布的《基金募集机构投资者适当性管理实施指引(试行)》，基金产品至少分为（　　）五个等级。",
            "question": "A. R1、R2、R3、R4和R5\nB. B1、B2、B3、B4和B5\nC. C1、C2、C3、C4和C5\nD. A1、B2、C3、D4和C5",
            "answer": "A",
            "explain": "根据基金业协会发布的《基金募集机构投资者适当性管理实施指引(试行)》，其产品至少分为五个等级：R1、R2、R3、R4和R5。"
        },
        {
            "title": "下列关于封闭式基金的表述，错误的是（　　）。",
            "question": "A. 价格与净值同比例下降时，折价率也下降\nB. 折价率反映了基金份额净值与二级市场价格之间的关系\nC. 市场价格低于份额净值时，为折价交易\nD. 市场价格高于份额净值时，为溢价交易",
            "answer": "A",
            "explain": "折（溢）价率反映封闭式基金份额净值与其二级市场价格之间的关系。折（溢）价率的计算公式为：折（溢）价率 =（二级市场价格 - 基金份额净值）/ 基金份额净值 × 100% =（二级市场价格 / 基金份额净值 - 1) × 100%，从公式中可以看出价格与净值同比例下降时，折价率不变。当二级市场价格低于基金份额净值时，为折价交易；当二级市场价格高于基金份额净值时，为溢价交易。"
        },
        {
            "title": "基金管理公司或基金代销机构使用基金宣传材料违规的，中国证监会依法采取的行政监管或行政处罚措施不包括（　　）。",
            "question": "A. 提示基金管理公司或基金代销机构进行改正\nB. 对基金管理公司或基金代销机构出具监管警示函\nC. 对直接负责的基金管理公司或基金代销机构高级管理人员和其他直接责任人员，采取监管谈话、出具警示函、记入诚信档案、暂停履行职务等\nD. 责令基金业协会或基金中介机构进行整改，暂停办理相关业务，并对其立案调查",
            "answer": "D",
            "explain": "D项应改为责令基金管理公司或基金代销机构进行整改，暂停办理相关业务，并对其立案调查。"
        },
        {
            "title": "下列关于中国证券投资基金业协会的职责的说法，正确的是（　　）。",
            "question": "A. I、II、IV\nB. I、II、III、IV\nC. II、III、IV\nD. II、IV",
            "questions": "I. 调解会员与客户之间的纠纷<br>II. 开展行业宣传和投资人教育活动<br>III. 检查会员及其从业人员的执业行为，并给予行政处罚<br>IV.依法办理私募基金管理人登记",
            "answer": "A",
            "explain": "基金业协会的职责除本题选项中的I、II、IV外，还包括：（1）教育和组织会员遵守有关证券投资的法律、行政法规，维护投资人合法权益，（2）依法维护会员的合法权益，反映会员的建议和要求，（3）制定和实施行业自律规则，监督、检查会员及其从业人员的执业行为，对违反自律规则和协会章程的，按照规定给予纪律处分。（4）制定行业执业标准和业务规范，组织基金从业人员的从业考试、资质管理和业务培训。"
        },
        {
            "title": "基金公司和代销机构共同为即将发行的新基金推介会聘请广告公司进行策划，其中符合基金销售机构人员行为规范的策划内容有（　　）。",
            "question": "A. 为参会者举办抽奖活动\nB. 举办买基金送保险的活动\nC. 宣传基金管理人将拿出一部分认购费收入回馈认购基金的投资者\nD. 宣传基金公司的过往业绩并同时声明过往业绩并不预示基金的未来表现",
            "answer": "D",
            "explain": "基金销售可以宣传过往业绩，但必须符合有关规定。"
        },
        {
            "title": "基金管理人的基金宣传推介材料，应报主要经营活动所在地（　　）备案。",
            "question": "A. 中国证监会\nB. 中国证监会派出机构\nC. 证券交易所\nD. 基金业协会",
            "answer": "B",
            "explain": "基金管理人的基金宣传推介材料，应自向公众分发或者发布之日起5个工作日内向中国证监会派出机构备案。"
        },
        {
            "title": "我国封闭式基金在达成交易后，二级市场交易份额和股份的交割是在T+0日，资金交割是在（　　）日完成。",
            "question": "A. T+0\nB. T+1\nC. T+2\nD. T+3",
            "answer": "B",
            "explain": ""
        }, {
            "title": "客户服务是基金营销的重要组成部分，下列不属于客户服务的是（　　）",
            "question": "A. 在发行新基金时群发手机短信以广而告之新基金发行的信息\nB. 向基金持有人解答各类疑问\nC. 通过电视向基金投资者传输正确的投资理念\nD. 向基金持有人邮寄投资策略报告",
            "answer": "A",
            "explain": "常见的客户服务内容包括基金账户信息查询、基金信息查询、基金管理公司信息查询、人工咨询、客户投诉处理、资料邮寄、基金转换、修改账户资料、非交易过户、挂失和解等服务。A项，群发新基金发行的信息属于基金宣传推介材料，是基金销售业务的范畴。"
        },
        {
            "title": "与其他金融工具相比较，开放式基金是一种（　　）",
            "question": "A. 债权凭证\nB. 收益凭证\nC. 信用凭证\nD. 受益凭证",
            "answer": "D",
            "explain": "投资基金按照运作方式，可以分为开放式、封闭式基金。投资基金是资产管理的主要方式之一，它是一种组合投资、专业管理、利益共享、风险共担的集合投资方式。它主要通过向投资者发行受益凭证（基金份额），将社会上的资金集中起来，交由专业的基金管理机构投资于各种资产，实现保值增值。"
        },
        {
            "title": "基金募集期限届满，基金不满足有关募集要求的，基金募集失败，基金管理人应承担的责任不包括（　　）",
            "question": "A. 在基金募集期限届满后30日内返还投资者的认购款项\nB. 以固有财产承担因募集行为而产生的债务和费用\nC. 向代销机构支付认购手续费\nD. 承担投资者认购款项的银行同期存款利息",
            "answer": "C",
            "explain": "基金募集期限届满，基金不满足有关募集要求的，基金募集失败，基金管理人应承担下列责任：(1)以固有财产承担因募集行为而产生的债务和费用；(2)在基金募集期限届满后30日内返还投资者已缴纳的款项，并加计银行同期存款利息。"
        },
        {
            "title": "合规独立性中，（　　）的独立性最为重要",
            "question": "A. 部门\nB. 机制\nC. 人员\nD. 问责",
            "answer": "A",
            "explain": "在合规独立性中，合规部门的独立性最为重要。"
        },
        {
            "title": "下列均为债券类金融资产的是（　　）",
            "question": "A. 基金、国债期货\nB. 可转债、票据\nC. 城投债、限售股\nD. 现金、定期分红蓝筹股",
            "answer": "B",
            "explain": "债券类金融资产以票据、债券等契约型投资工具为主。"
        },
        {
            "title": "世界上第一只公认的证券投资基金海外及殖民地政府信托，诞生于（　　）",
            "question": "A. 美国\nB. 英国\nC. 法国\nD. 德国",
            "answer": "B",
            "explain": "世界上第一只公认的证券投资基金海外及殖民地政府信托诞生于1868年的英国。"
        },
        {
            "title": "基金销售机构在制定投资者教育策略时，首先应考虑（　　）",
            "question": "A. 预测证券市场走势\nB. 寻找确保本金安全的投资策略\nC. 选择高收益投资产品\nD. 普及证券市场知识和宣传证券市场法规",
            "answer": "D",
            "explain": "目前，各国投资者教育机构在制定投资者教育策略时，都首先致力于普及证券市场知识和宣传证券市场法规。"
        },
        {
            "title": "既注重资本增值又注重当期收入的证券投资基金是（　　）",
            "question": "A. 指数基金\nB. 增长型基金\nC. 收入型基金\nD. 平衡型基金",
            "answer": "D",
            "explain": "根据投资目标的不同，可以将基金分为增长型基金、收入型基金和平衡型基金。其中，平衡型基金是既注重资本增值又注重当期收入的证券投资基金。"
        },
        {
            "title": "对冲基金起源于（　　）",
            "question": "A. 美国\nB. 加拿大\nC. 日本\nD. 美国",
            "answer": "D",
            "explain": "对冲基金起源于20世纪50年代初的美国，当时的宗旨在于利用期货、期权等金融衍生产品以及对相关联的股票进行买空卖空、风险对冲的操作技巧，在一定程度上规避和化解投资风险。"
        },
        {
            "title": "信息披露义务人将不存在的事实在基金信息披露文件中予以记载的行为属于（　　）",
            "question": "A. 重大遗漏\nB. 不当竞争\nC. 虚假记载\nD. 误导性陈述",
            "answer": "C",
            "explain": "虚假记载是指信息披露义务人将不存在的事实在基金信息披露文件中予以记载的行为；误导性陈述是指使投资者对基金投资行为发生错误判断并产生重大影响的陈述；重大遗漏是指披露中存在应披露而未披露的信息，以至于影响投资者做出正确决策。以上三类行为将扰乱市场正常秩序，侵害投资者合法权益，属于严重的违法行为。"
        },
        {
            "title": "关于投资人办理封闭式基金认购申请业务，以下表述错误的是（　　）",
            "question": "A. 认购申请已经受理后可以申请撤单\nB. 投资者需开立沪、深证券账户\nC. 投资者也可以开立沪、深证券账户及资金账户\nD. 投资者可以按'份额'提交认购申请",
            "answer": "A",
            "explain": "拟认购封闭式基金份额的投资人必须开立沪、深证券账户或沪、深基金账户及资金账户，根据自己的计划认购量在资金账户中存入足够的资金，并以'份额'为单位提交认购申请。认购申请已经受理就不能撤单。"
        },
        {
            "title": "下列属于股票、债券型开放式基金申购赎回原则的是（　　）",
            "question": "A. I、IV\nB. II、IV\nC. I、III\nD. II、III",
            "questions": "I. 未知价交易原则<br>II. 确定价原则<br>III. 份额申购、份额赎回原则<br>IV.金额申购、份额赎回原则",
            "answer": "A",
            "explain": "股票基金、债券基金的申购和赎回的原则包括：（1）未知价交易原则。（2）金额申购、份额赎回原则。"
        },
        {
            "title": "承担高风险、追求高收益的投资模式的投资基金是（　　）",
            "question": "A. 风险投资基金\nB. 分级基金\nC. 另类投资基金\nD. 对冲基金",
            "answer": "D",
            "explain": "对冲基金是基于投资理论和极其复杂的金融市场操作技巧，充分利用各种金融衍生产品的杠杆效应，承担高风险、追求高收益的投资模式。"
        },
        {
            "title": "不收取销售服务费的，对持续持有期长于3个月但少于6个月的投资人收取不低于0.5%的赎回费，并将不低于赎回费总额的（　　）计入基金财产",
            "question": "A. 75%\nB. 60%\nC. 50%\nD. 25%",
            "answer": "C",
            "explain": "不收取销售服务费的，对持续持有期长于3个月但少于6个月的投资人收取不低于0.5%的赎回费，并将不低于赎回费总额的50%计入基金财产。"
        },
        {
            "title": "私募基金管理人自成为基金业协会的观察会员之日起满（　　）年，同时符合管理规模标准和合规经营目标，可以申请为普通会员",
            "question": "A. 1\nB. 半\nC. 2\nD. 3",
            "answer": "A",
            "explain": "私募基金管理人和从事私募资产管理业务的金融机构加入协会，应当先申请成为观察会员，自成为观察会员之日起满1年，同时符合资产管理规模标准及合规经营标准的，可申请成为普通会员。"
        },
        {
            "title": "投资基金的主要当事人不包括（　　）",
            "question": "A. 基金委托人\nB. 基金托管人\nC. 基金管理人\nD. 基金投资者",
            "answer": "A",
            "explain": "投资基金主要是一种间接投资工具，基金投资者、基金管理人和托管人是基金运作中的主要当事人，其中基金投资者即为基金份额持有人。"
        },
        {
            "title": "某基金管理公司出现以下四项风险事件，其中属于信用风险的是（　　）",
            "question": "A. 货币市场基金持仓债券估值大幅下跌，导致基金组合整体出现估值负偏离\nB. 投资组合重仓限售证券，从而无法应对客户大额赎回要求的资金\nC. 投资组合的持仓债券到期前，债券发行人公告称因公司财务欠佳无法如期支付本息\nD. 由于汇率市场波动，导致QDII基金的损益波动较大",
            "answer": "C",
            "explain": "AB项属于流动性风险，D项属于汇率风险。"
        },
        {
            "title": "基金销售机构应通过网络或其他方式向社会公示本机构所属的取得基金销售从业资质的人员信息，公示的内容不包括（　　）",
            "question": "A. 家庭住址\nB. 从业资质证明\nC. 所在营业网点\nD. 从业资质证明编号",
            "answer": "A",
            "explain": "基金销售机构应通过网络或其他方式向社会公示本机构所属的取得基金销售从业资质的人员信息，公示的内容包括但不限于姓名、从业资质证明及编号、所在营业网点等信息。"
        },
        {
            "title": "下列不属于信息披露内容应遵循的原则的是（　　）",
            "question": "A. 真实性原则\nB. 准确性原则\nC. 完整性原则\nD. 公正性原则",
            "answer": "D",
            "explain": "在披露内容上，信息披露应遵循的原则包括真实性原则、准确性原则、完整性原则、及时性原则和公平性原则。"
        },
        {
            "title": "基金经营机构应妥善保存交易时段客户交易区的监控录像资料，保存期限不得少于（　　）个月",
            "question": "A. 1\nB. 2\nC. 3\nD. 6",
            "answer": "D",
            "explain": "基金经营机构应妥善保存交易时段客户交易区的监控录像资料，保存期限不得少于6个月。"
        },
        {
            "title": "（　　）是判定是否构成操纵市场的关键因素",
            "question": "A. 是否有误导市场参与者的意图\nB. 实施了操纵证券价格的行为\nC. 人为虚增交易量\nD. 传播虚假信息",
            "answer": "A",
            "explain": ""
        }, {
            "title": "ETF基金在基金合同生效日后不超过（　　）个月的时间起开始办理赎回",
            "question": "A. 2\nB. 3\nC. 4\nD. 6",
            "answer": "B",
            "explain": "在基金份额折算日之后可开始办理申购ETF基金，自基金合同生效日后不超过3个月的时间起开始办理赎回。"
        },
        {
            "title": "中国证监会对基金机构的检查内容不包括（　　）",
            "question": "A. 合规监控\nB. 内部稽核\nC. 收益大小\nD. 行为规范",
            "answer": "C",
            "explain": "中国证监会对基金机构的检查内容包括：合规监控、风险管理、内部稽核和行为规范。"
        },
        {
            "title": "CPPI是一种通过比较投资组合现时净值与投资组合价值底线，从而动态调整投资组合中（　　）与保本资产的比例，以兼顾保本与增值目标的保本策略",
            "question": "A. 现时总值\nB. 风险资产\nC. 投资组合价值平均线\nD. 保本收益",
            "answer": "B",
            "explain": "CPPI是一种通过比较投资组合现时净值与投资组合价值底线，从而动态调整投资组合中风险资产与保本资产的比例，以兼顾保本与增值目标的保本策略。"
        },
        {
            "title": "基金管理人的基金宣传推介材料，应自向公众分发或者发布之日起（　　）个工作日内向中国证监会派出机构备案",
            "question": "A. 3\nB. 5\nC. 7\nD. 10",
            "answer": "B",
            "explain": "基金管理人的基金宣传推介材料，应自向公众分发或者发布之日起5个工作日内向中国证监会派出机构备案。"
        },
        {
            "title": "某基金公司的如下行为中，符合公平对待客户原则的是（　　）",
            "question": "A. 不同基金组合同时参加股票的非公开定向增发，按照各基金组合的申购量，按比例分配中签结果\nB. 对于有认购规模上限的新发基金，优先确认大额资金的认购申请\nC. 直销柜台拒绝受理当日15点后的基金申购\nD. 某基金遭遇巨额赎回，基金公司根据基金合同的约定，决定对所有赎回申请采取部分延迟赎回的处理方式",
            "answer": "B",
            "explain": "公平对待客户，是指基金从业人员应当平等对待所有客户并公平对待所有客户，不能因为基金份额多少或者其他原因而厚此薄彼，公平对待客户要求基金从业人员在进行投资分析、提供投资建议、采取投资行动或从事其他专业活动时，应当公平地对待所有客户。"
        },
        {
            "title": "关于基金职业道德修养，以下选项错误的是（　　）",
            "question": "A. 正确树立基金职业道德观念\nB. 侧重内在自我学习，不需要外在教育灌输\nC. 积极参加基金职业道德实践\nD. 深刻领会基金职业道德规范",
            "answer": "B",
            "explain": "基金职业道德修养必须首先解决内在动力问题，即必须正确树立基金职业道德观念。基金职业道德规范是基金职业道德修养的具体内容，基金职业道德修养不能脱离基金职业道德规范，一定是针对基金职业道德规范的自我教育、自我改造和自我完善。基金职业道德修养，一方面要自我学习基金职业道德规范，另一方面要主动接受基金职业道德教育。树立基金职业道德观念和领会基金职业道德规范的根本目的在于践行基金职业道德。积极参加基金职业道德实践，是基金职业道德修养的有效途径。"
        },
        {
            "title": "基金经营机构应妥善保存客户交易终端信息和开户资料电子化信息，保存期限不得少于（　　）年",
            "question": "A. 5\nB. 10\nC. 15\nD. 20",
            "answer": "D",
            "explain": "根据基金经营机构客户信息保存期限有关规定：基金经营机构应妥善保存客户交易终端信息和开户资料电子化信息，保存期限不得少于20年。"
        },
        {
            "title": "诚实守信的基本要求不包括（　　）",
            "question": "A. 不得欺诈客户\nB. 不得从事与投资人利益相冲突的业务\nC. 不得进行内幕交易和操纵市场\nD. 不得进行不正当竞争",
            "answer": "B",
            "explain": "诚实守信要求基金从业人员不得欺诈客户，在证券投资活动中不得有内幕交易和操纵市场行为，对于同行不得进行不正当竞争。B项属于客户利益优先的要求。"
        },
        {
            "title": "下列关于ETF份额的说法，错误的是（　　）",
            "question": "A. ETF基金份额折算对基金份额持有人的收益无实质性影响\nB. 在发生暂停申购和赎回的情形之一时，基金的申购和赎回不会同时暂停\nC. ETF份额折算的登记是由基金管理人办理\nD. ETF份额折算时，持有人持有的基金份额占基金份额总额的比例不发生变化",
            "answer": "B",
            "explain": "在发生暂停申购和赎回的情形之一时，基金的申购和赎回可能同时暂停。在暂停申购和赎回的情况消除时，基金管理人应及时恢复申购和赎回业务的办理，并予以公告。"
        },
        {
            "title": "证券交易所在监控中发现基金交易行为异常，涉嫌违法违规的，可以根据具体情况，采取（　　）等措施",
            "question": "A. 取消资格\nB. 没收违法所得\nC. 罚款\nD. 电话提示、警告",
            "answer": "D",
            "explain": "证券交易所在监控中发现基金交易行为异常，涉嫌违法违规的，可以根据具体情况，采取电话提示、警告、约见谈话、公开谴责等措施，并同时向中国证监会报告。"
        }, {
            "title": "关于证券投资基金利益共享、风险共担的特点，下列说法错误的是（　　）",
            "question": "A. 基金扣除费用后的盈余由基金合同当事人共同享有\nB. 基金投资收益可以根据基金合同约定分配而不按份额比例分配\nC. 基金投资损失由基金份额持有人共同承担\nD. 基金管理人也可以收取与基金投资收益挂钩的浮动报酬",
            "answer": "A",
            "explain": "基金投资者是基金的所有者。基金投资收益在扣除由基金承担的费用后的盈余全部归基金投资者所有，基金投资者一般按照所持有的基金份额比例进行分配。为基金提供服务的基金托管人、基金管理人一般按基金合同的规定从基金资产中收取一定比例的托管费、管理费，并不参与基金收益的分配，也有一些特殊的基金不按照基金份额比例而按照基金合同的规定分配收益，如分级基金。也有一些基金根据基金合同规定按照基金的投资收益采取浮动费率制度或者提取业绩报酬。"
        },
        {
            "title": "在公开募集基金的基金管理人被责令停业整顿、被依法指定托管、接管或者清算期间，或者出现重大风险时，经中国证监会批准，可以对基金管理人直接负责的董事、监事、高级管理人员和其他直接责任人员采取的措施不包括（　　）",
            "question": "A. 通知出境管理机关依法阻止其出境\nB. 申请司法机关禁止其转移、转让或者以其他方式处分财产\nC. 在财产上设定其权利\nD. 冻结资金账户或证券账户",
            "answer": "D",
            "explain": "在公开募集基金的基金管理人被责令停业整顿、被依法指定托管、接管或者清算期间，或者出现重大风险时，经中国证监会批准，可以对基金管理人直接负责的董事、监事、高级管理人员和其他直接责任人员采取的措施包括：（1）通知出境管理机关依法阻止其出境；(2)申请司法机关禁止其转移、转让或者以其他方式处分财产，或者在财产上设定其权利。"
        },
        {
            "title": "关于基金份额转换的规则，下列说法正确的是（　　）",
            "question": "A. 基金份额的转换不需要额外支付转换费用\nB. 一般采用未知价法\nC. 基金份额的转换不需缴纳转出基金的赎回费，需要支付转入基金的申购费\nD. 按照转换申请日下一日的单位净值计算转换基金的份额数量",
            "answer": "B",
            "explain": "开放式基金份额的转换是指投资者不需要先赎回已持有的基金份额，就可以将其持有的基金份额转换为同一基金管理人管理的另一基金份额的一种业务模式。基金份额的转换一般采取未知价法，按照转换申请日的基金份额净值为基础计算转换基金份额数量。基金份额的转换常常还会收取一定的转换费用。尽管如此，由于基金份额的转换不需要先赎回已持有的基金再购买另一基金，因此，综合费用仍较低。"
        },
        {
            "title": "基金管理公司在6个月内连续两次出具警示函，则应该提前（　　）个工作日递交报告材料到证监会进行备案",
            "question": "A. 3\nB. 5\nC. 7\nD. 10",
            "answer": "D",
            "explain": "基金管理公司或基金代销机构应当在分发或者公布基金宣传推介材料之日起5个工作日内报送报告材料。如果6个月内连续两次出具警示函，则应该提前10个工作日递交报告材料到证监会进行备案。"
        },
        {
            "title": "投资者基金份额账户由（　　）建立",
            "question": "A. 基金注册登记机构\nB. 中央结算公司\nC. 基金销售机构\nD. 基金托管人",
            "answer": "A",
            "explain": "基金注册登记机构的主要职责包括：建立并管理投资者基金份额账户；负责基金份额登记，确认基金交易；发放红利；建立并保管基金投资者名册；基金合同或者登记代理协议规定的其他职责。"
        },
        {
            "title": "下列不属于公司员工违反忠实义务行为的是（　　）",
            "question": "A. 以任何行为欺骗任何公司现有或将来的客户\nB. 对重大事实作虚假或隐瞒重要事实，该事实隐瞒会使得其陈述有误导性质\nC. 勤勉尽责，遵守公司章程\nD. 参与任何操纵市场的行为",
            "answer": "C",
            "explain": "公司员工违反忠实义务的行为包括：(1)以任何行为欺骗任何公司现有或将来的客户；(2)对重大事实作虚假或隐瞒重要事实，该事实隐瞒会使得其陈述有误导性质；(3)参与任何对客户或将来的客户构成欺诈或欺骗的行为、实践或商业交往；(4)参与任何操纵市场的行为；(5)向任何其他人提供关于客户、公司的任何证券交易或与之有关的信息。"
        },
        {
            "title": "（　　）是各类基金销售机构未来的发展重点",
            "question": "A. 深度挖掘互联网销售的效能\nB. 提高销售人员的专业水平\nC. 增加基金的投资种类\nD. 提升服务的专业化和层次化",
            "answer": "D",
            "explain": "提升服务的专业化和层次化是各类基金销售机构未来的发展重点。"
        },
        {
            "title": "（　　）是对基金销售业务以及人际关系的维护",
            "question": "A. 基金客户档案管理与保密\nB. 基金客户投诉处理\nC. 基金投资咨询与互动交流\nD. 基金投资跟踪与评价",
            "answer": "D",
            "explain": "基金投资跟踪与评价是对基金销售业务以及人际关系的维护。"
        },
        {
            "title": "下列属于购买该基金的合格投资人的是（　　）",
            "question": "A. 甲\nB. 丙\nC. 丁\nD. 乙",
            "answer": "A",
            "explain": "私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人：（1）净资产不低于1000万元的单位；（2）金融资产不低于300万元或者……"
        }, {
            "title": "本题中属于违规行为的是（　　）",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、IV\nD. I、II、III",
            "questions": "I. 乙通过微信朋友圈推介基金产品<br>II. 乙购买100万元基金产品<br>III. 甲乙丙丁凑齐150万元购买基金<br>IV. 乙用凑齐的资金以自己的名义购买150万元基金产品",
            "answer": "B",
            "explain": "非公开募集基金，不得向合格投资者之外的单位和个人募集资金，不得通过报刊、电台、电视台、互联网等公众传播媒体或者讲座、报告会、分析会和布告、传单、手机短信、微信、博客和电子邮件等方式向不特定对象宣传推介，I项错误。投资者应当确保投资资金来源合法，不得非法汇集他人资金投资私募基金，Ⅲ、IV项错误。"
        },
        {
            "title": "该案例违规行为主要体现在（　　）",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、IV\nD. I、II、III",
            "questions": "I. 非法汇集他人资金<br>II. 违反规定向合格投资人以外的个人募集资金<br>III. 向不特定的对象宣传推介基金产品<br>IV. 违规接受低于最低限额的申购",
            "answer": "D",
            "explain": "投资者应当确保投资资金来源合法，不得非法汇集他人资金投资私募基金，I项错误。非公开募集基金应当向合格投资者募集，合格投资者累计不得超过200人，Ⅱ项错误。非公开募集基金，不得向合格投资者之外的单位和个人募集资金，不得通过报刊、电台、电视台、互联网等公众传播媒体或者讲座、报告会、分析会和布告、传单、手机短信、微信、博客和电子邮件等方式向不特定对象宣传推介，Ⅲ项错误。"
        },
        {
            "title": "（　　）是具有独立法人地位的股份投资公司，基金投资者是基金公司的股东，享有股东权利，按所持有的股份承担有限责任，分享投资收益",
            "question": "A. 契约型基金\nB. 公司型基金\nC. 开放式基金\nD. 封闭式基金",
            "answer": "B",
            "explain": "公司型基金是具有独立法人地位的股份投资公司，是依据公司章程设立，基金投资者是基金公司的股东，享有股东权，按所持有的股份承担有限责任，分享投资收益。"
        },
        {
            "title": "根据中国证监会颁布的关于基金管理公司治理法律法规，下列属于基金公司治理结构要求的是（　　）",
            "question": "A. I、II\nB. I、II、IV\nC. I、II、III、IV\nD. I、II、III",
            "questions": "I. 组织机构健全\nII. 职责划分清晰\nII. 制衡监督有效\nIV. 激励约束合理",
            "answer": "C",
            "explain": "《证券投资基金法》、《证券投资基金管理公司管理办法》和《证券投资基金管理公司治理准则（试行）》对基金管理公司治理的目标、原则、结构有明确的规定，设计了独特的独立董事制度、督察长制度，要求基金管理公司建立组织机构健全、职责划分清晰、制衡监督有效、激励约束合理的治理结构，保持公司规范运作。"
        },
        {
            "title": "采用封闭式运作方式的基金具有（　　）",
            "question": "A. 在合同期限内，基金管理人和基金托管人协商一致并公告，可以临时开放申购和赎回\nB. 在合同期限内，基金份额持有人不能申请申购，但可以申请赎回\nC. 基金份额总额在基金合同期限内固定不变\nD. 基金资产总值在合同期限内固定不变",
            "answer": "C",
            "explain": "封闭式基金是指基金份额在基金合同期限内固定不变，基金份额可以在依法设立的证券交易所交易，但基金份额持有人不得申请赎回的一种基金运作方式。"
        },
        {
            "title": "下列各项中属于基金管理人内部控制基本要素的是（　　）",
            "question": "A. 控制成本\nB. 控制利润\nC. 控制目标\nD. 控制环境",
            "answer": "D",
            "explain": "基金管理人内部控制的基本要素包括控制环境、风险评估、控制活动、信息沟通和内部控制五个方面。"
        },
        {
            "title": "对基金投资人进行风险承受能力调查，应当从调查结果中了解到基金投资人的情况不包括（　　）",
            "question": "A. 投资目的\nB. 财务状况\nC. 短期风险承受水平\nD. 中期风险承受水平",
            "answer": "D",
            "explain": "对基金投资人进行风险承受能力调查，应当从调查结果中了解到基金投资人的情况包括：投资目的、投资期限、投资经验、财务状况、短期风险承受水平和长期风险承受水平。"
        },
        {
            "title": "在进行投资决策业务控制时，应建立（　　），在设定的风险权限额度内进行投资决策",
            "question": "A. 投资决策授权制度\nB. 业务交流制度\nC. 投资风险评估与管理制度\nD. 实质性审查制度",
            "answer": "C",
            "explain": "投资决策业务控制时的主要内容之一：建立投资风险评估与管理制度，在设定的风险权限额度内进行投资决策。"
        }, {
            "title": "中国证监会一般工作人员离职后（　　）年内，不得到与原来工作业务直接相关的机构任职",
            "question": "A. 1\nB. 2\nC. 3\nD. 5",
            "answer": "B",
            "explain": "中国证监会一般工作人员离职后2年内，不得到与原来工作业务直接相关的机构任职。"
        },
        {
            "title": "保守机密的要求不包括（　　）",
            "question": "A. 应当妥善保管并严格保守客户秘密\nB. 不得泄露在执业活动中所获知的信息\nC. 严格遵守交易机构的制度和工作流程\nD. 不得泄露在执业活动中所获知的内幕信息",
            "answer": "C",
            "explain": "保守机密的要求包括：（1）应当妥善保管并严格保守客户秘密，非经许可不得泄露客户资料和交易信息；(2)不得泄露在执业活动中所获知的各相关方的信息及所属机构的商业秘密，更不得以为自己或他人谋取不正当利益；(3)不得泄露在执业活动中所获知的内幕信息。"
        },
        {
            "title": "货币市场基金合同生效后，基金管理人开始办理基金份额申购、赎回当日，其封闭期的收益公告应当披露（　　）",
            "question": "A. II、IV\nB. I、III、IV\nC. I、II、III\nD. I、II",
            "questions": "I. 截至前一日的基金资产净值<br>II. 前一日的每万份基金收益<br>III. 基金合同生效日至前一日期间的每万份基金收益<br>IV. 前一日的7日年化收益率",
            "answer": "B",
            "explain": "封闭期的收益公告是指货币市场基金的基金合同生效后，基金管理人于开始办理基金份额申购或者赎回当日，在中国证监会指定的报刊和基金管理人网站上披露截至前一日的基金资产净值，基金合同生效日至前一日期间的每万份基金净收益，前一日的7日年化收益率。"
        },
        {
            "title": "在每年结束后（　　）日内，在指定报刊上披露年度报告摘要，在管理人网站上披露年度报告全文",
            "question": "A. 2\nB. 15\nC. 60\nD. 90",
            "answer": "D",
            "explain": "在每年结束后90日内，在指定报刊上披露年度报告摘要，在管理人网站上披露年度报告全文。"
        },
        {
            "title": "如果基金募集期限届满后不能成立，基金管理人要在基金募集期限届满后（　　）日内返还投资者已缴纳的款项，并加计银行同期存款利息",
            "question": "A. 7\nB. 10\nC. 15\nD. 30",
            "answer": "D",
            "explain": "基金募集期限届满，基金不满足有关募集要求的基金募集失败，基金管理人应承担下列责任：（1）以固有资产承担因募集行为而产生的债务和费用；(2)在基金募集期限届满后30日内返还投资者已缴纳的款项，并加计银行同期存款利息。"
        },
        {
            "title": "基金销售协议的内容包括（　　）",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. I、II",
            "questions": "I. 销售费用分配比例和方式<br>II. 基金投资收益分配比例和方式<br>III. 客户资料保存方式及对基金持有人的持续服务责任<br>IV. 反洗钱义务履行及责任划分",
            "answer": "A",
            "explain": "基金销售机构办理基金的销售业务，应当由基金销售机构与基金管理人签订书面销售协议，明确双方的权利及义务，并至少包括以下内容：销售费用分配的比例和方式，基金持有人联系方式等客户资料的保存方式，对基金持有人的持续服务责任，反洗钱义务履行及责任划分，基金销售信息交换及资金交收权利与义务。"
        },
        {
            "title": "基金业协会应当在私募基金管理人登记材料齐备后的（　　）个工作日内，为私募基金管理人办理登记手续",
            "question": "A. 7\nB. 10\nC. 15\nD. 20",
            "answer": "D",
            "explain": "基金业协会应当在私募基金管理人登记材料齐备后的20个工作日内，通过网站公告私募基金管理人名单及其基本情况的方式，为私募基金管理人办理登记手续。"
        },
        {
            "title": "关于股票和股票基金，下列说法错误的是（　　）",
            "question": "A. 股票可以根据一定的标准划分为不同的类型，也可以根据一定的标准对股票基金进行分类\nB. 单一股票的投资风险较大、收益相对较高，而股票基金的风险相对较小、收益相对稳定\nC. 当日股票价格会受到交易量的影响，而当日股票基金份额净值不受当天申购和赎回数量的影响\nD. 股票的价格往往在每一个交易日内不断变动，每一个交易日非上市股票基金的价格也不断变动",
            "answer": "D",
            "explain": "股票价格在每一交易日内始终处于变动之中；股票基金份额净值的计算每天只进行1次。因此每一交易日股票基金只有1个价格。"
        },
        {
            "title": "下列对期货市场交易的说法正确的是（　　）",
            "question": "A. 协议成交和标的交割是同时进行的\nB. 对交易双方来说，利率和汇率风险很小\nC. 交易对象价格的升降不会影响交易者的利润或损失\nD. 买者和卖者只能依靠自己对市场未来的判断进行交易",
            "answer": "D",
            "explain": "A项，期货市场的交易在协议达成后并不立刻交割，而是约定在某一特定时间后进行交割，协议成交和标的交割是分离的；B项，由于期货市场的成交与交割之间有时间间隔，因而对交易双方来说，利率和汇率风险很大；CD两项，在期货交易中，由于交割要按成交时的协议价格进行，交易对象价格的升降，就可能使交易者获得利润或蒙受损失，因此，买者和卖者只能依靠自己对市场未来的判断进行交易。"
        },
        {
            "title": "基本管理制度的内容不包括（　　）",
            "question": "A. 收益核算\nB. 投资管理\nC. 信息披露\nD. 公司财务",
            "answer": "A",
            "explain": ""
        }, {
            "title": "中小投资者由于资金量小，一般无法购买数量众多的股票分散投资风险。基金通常会购买几十种甚至上百种股票，可以用其他股票价格上涨产生的盈利来弥补某些股票价格下跌的风险。这属于证券投资基金的（　　）特点",
            "question": "A. 组合投资、分散风险\nB. 利益共享、风险共担\nC. 集合理财、专业管理\nD. 独立托管、保障安全",
            "answer": "A",
            "explain": "中小投资者由于资金量小，一般无法购买数量众多的股票分散投资风险。基金通常会购买几十种甚至上百种股票，可以用其他股票价格上涨产生的盈利来弥补某些股票价格下跌的风险，这是对组合投资、分散风险特点的描述。"
        },
        {
            "title": "关于基金与股票所反映的经济关系，以下表述错误的是（　　）",
            "question": "A. 股票反映的是一种所有权关系\nB. 投资者购买基金份额就成为基金的受益人\nC. 投资者购买股票后就成为公司的债权人\nD. 基金反映的是一种信托关系",
            "answer": "C",
            "explain": "股票反映的是一种所有权关系，是一种所有权凭证，投资者购买股票后就成为公司的股东；债券反映的是债权债务关系，是一种债权凭证，投资者购买债券后就成为公司的债权人；基金反映的则是一种信托关系，是一种受益凭证，投资者购买基金份额就成为基金的受益人。"
        },
        {
            "title": "与普通的开放式基金不同，ETF份额（　　）",
            "question": "A. 只能以现金认购\nB. 只能以证券认购\nC. 既可以用现金认购，也可以用证券认购\nD. 既不能用现金认购，也不能用证券认购",
            "answer": "C",
            "explain": "与普通的开放式基金不同，根据投资者认购ETF份额所支付的对价种类，ETF份额的认购又可分为现金认购和证券认购。现金认购是指用现金换购ETF份额的行为，证券认购是指用指定证券换购ETF份额的行为。"
        },
        {
            "title": "（　　）风险是指因未能遵循法律法规、监管规定、规则、自律性组织制定的有关准则，以及适用于自身业务活动的行为准则而可能遭受法律制裁或监管处罚、重大财务损失或声誉损失的风险",
            "question": "A. 系统\nB. 非系统\nC. 财务\nD. 合规",
            "answer": "D",
            "explain": "合规风险是指因未能遵循法律法规、监管规定、规则、自律性组织制定的有关准则，以及适用于自身业务活动的行为准则而可能遭受法律制裁或监管处罚、重大财务损失或声誉损失的风险。"
        },
        {
            "title": "私募基金管理人在备案私募基金时，应如实填报的信息包括（　　）",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、IV\nD. I、II、IV",
            "questions": "I. 基金名称<br>II. 资本规模<br>III. 投资者<br>IV. 基金合同",
            "answer": "B",
            "explain": "私募基金管理人应当在私募基金募集完毕后20个工作日内，通过私募基金登记备案系统进行备案，并根据私募基金的主要投资方向注明基金类别，如实填报基金名称、资本规模、投资者、基金合同（基金公司章程或者合伙协议，统称基金合同）等基本信息。"
        },
        {
            "title": "下列不属于风险应对措施的是（　　）",
            "question": "A. 风险评估\nB. 风险接受\nC. 风险回避\nD. 风险共担",
            "answer": "A",
            "explain": "基金管理人要对每一个重要的风险及其对应的回报进行评价和平衡，采取包括回避、接受、共担或降低这些风险等措施，风险应对是企业风险管理的整体重要组成部分。"
        },
        {
            "title": "办理基金备案手续时应向基金业协会报送的信息不包括（　　）",
            "question": "A. 主要投资方向及根据主要投资方向注明的基金类别\nB. 基金管理人的财务状况\nC. 基金合同\nD. 采取委托管理方式的，应当报送委托管理协议",
            "answer": "B",
            "explain": "私募基金管理人办理基金备案手续后，应当向基金业协会报送的信息包括：（1）主要投资方向及根据主要投资方向注明的基金类别。（2）基金合同、公司章程或者合伙协议，资金募集过程中向投资者提供基金招募说明书的，应当报送基金招募说明书，以公司、合伙等企业形式设立的私募基金，还应当报送工商登记和营业执照正副本复印件。（3）采取委托管理方式的，应当报送委托管理协议。委托托管机构托管基金财产的，还应当报送托管协议。（4）基金业协会规定的其他信息。"
        },
        {
            "title": "关于基金的信息披露，下列表述正确的是（　　）",
            "question": "A. III、IV\nB. I、III\nC. II、III\nD. II、IV",
            "questions": "I. 封闭式基金在披露临时报告后2日内，送基金上市的证券交易所审核<br>II. 某基金成立于4月6日，该基金不需要编制第二季度报告<br>III. 当发生对基金份额持有人权益或者基金价格产生重大影响的事件时，应在2日内编制并披露临时报告书<br>IV. 货币市场基金若遇法定节假日，应于节假日结束后第一个自然日，披露节假日期间的每万份基金净收益，节假日最后一日的7日年化收益率",
            "answer": "C",
            "explain": "封闭式基金应在披露临时报告前送基金上市的证券交易所审核，I项错误。货币市场基金开放申购赎回后，在遇到法定节假日时，于节假日结束后第二个自然日披露节假日期间的每万份基金净收益，节假日最后一日的7日年化收益率，以及节假日后首个开放日的每万份基金净收益和7日年化收益率，IV项错误。"
        }, {
            "title": "关于股票和股票基金，以下描述错误的是（　　）",
            "question": "A. 股票价格在每一个交易日内始终处于变动中，股票基金份额净值的计算每天只进行一次\nB. 股票基金的投资风险相对低于股票投资的风险\nC. 投资者可以评估股票价格被高估或低估，但股票基金份额净值是客观的\nD. 股票的价格会受到投资者买卖的影响，但股票基金份额净值不受交易日当日投资者申购或赎回的影响",
            "answer": "A",
            "explain": "股票价格在每一个交易日内始终处于变动中；股票基金份额净值的计算每天只进行一次，因此每一交易日股票基金只有一个价格。"
        },
        {
            "title": "关于货币市场基金季度报告中有关偏离度的信息披露，下列披露内容错误的是（　　）",
            "question": "A. 报告期内偏离度的最高值\nB. 报告期内偏离度绝对值在0.25%~0.5%\nC. 报告期内偏离度的最低值\nD. 报告期内偏离度的简单平均值",
            "answer": "D",
            "explain": "在季度报告的投资组合报告中，货币市场基金将披露报告期内偏离度绝对值在0.25%~0.5%间的次数、偏离度的最高值和最低值、偏离度绝对值的简单平均值等信息。"
        },
        {
            "title": "下列基金公司基金销售活动中不属于直销业务的是（　　）",
            "question": "A. 基金公司渠道经理通过商业银行销售基金产品\nB. 基金公司销售人员维护机构客户\nC. 基金公司销售人员开发高净值个人客户\nD. 基金公司通过自主开发建立的电子商务平台销售基金产品",
            "answer": "A",
            "explain": "基金直销是指通过基金公司或基金公司网站进行基金买卖。因此直销机构仅销售一家基金公司的产品。基金代销是指拥有代销资格的银行或证券公司等金融机构接受基金管理人的委托，通过营业网点柜台、电话、网络等渠道为投资人办理基金份额认购、申购和赎回以及相应资金的收付业务。因此代销机构往往同时销售多家基金公司产品。A项属于基金代销。"
        },
        {
            "title": "下列不属于全球基金发展的趋势及特点的是（　　）",
            "question": "A. 日本基金居于主流\nB. 开放式基金远超封闭式基金\nC. 基金业竞争加剧，行业集中度高\nD. 基金资产来源以养老计划为主",
            "answer": "A",
            "explain": "全球基金发展的趋势包括：美国基金居于主流；开放式基金远超封闭式基金；基金业竞争加剧，行业集中度高；基金资产来源以养老计划为主；ETF等被动基金规模迅速扩大，另类投资基金兴起。"
        },
        {
            "title": "货币市场基金收益公告需要披露收益公告，包括每万份基金收益和最近（　　）日年化收益率",
            "question": "A. 3\nB. 5\nC. 7\nD. 10",
            "answer": "C",
            "explain": "货币市场基金收益公告需要披露收益公告，包括每万份基金收益和最近7日年化收益率。"
        },
        {
            "title": "基金宣传推介材料登载该基金和基金管理人管理的其他基金的过往业绩时，基金管理人应特别声明（　　）",
            "question": "A. 基金的过往业绩说明基金管理人有很好的投资能力\nB. 本基金的业绩可以达到过往业绩的平均水平\nC. 本基金的业绩以过往业绩的平均水平为底线\nD. 基金的过往业绩并不预示其未来表现，基金管理人管理的其他基金的业绩并不构成新基金业绩表现的保证",
            "answer": "D",
            "explain": "2013年6月1日起施行的《证券投资基金销售管理办法》第三十八条规定，基金宣传推介材料登载基金过往业绩的，应当特别声明，基金的过往业绩并不预示其未来表现，基金管理人管理的其他基金的业绩并不构成基金业绩表现的保证。"
        },
        {
            "title": "（　　）负责组织指导公司监察稽核工作，履行职责的范围应当涵盖基金及公司运作的所有业务环节",
            "question": "A. 总经理\nB. 部门主管\nC. 部门经理\nD. 督察长",
            "answer": "D",
            "explain": "督察长负责组织指导公司监察稽核工作，履行职责的范围应当涵盖基金及公司运作的所有业务环节。"
        },
        {
            "title": "私募基金管理人、私募基金托管人及私募基金销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录和其他相关资料，保存期限自基金清算终止之日起不得少于（　　）年",
            "question": "A. 3\nB. 5\nC. 10\nD. 20",
            "answer": "C",
            "explain": "私募基金管理人、私募基金托管人及私募基金销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录和其他相关资料，保存期限自基金清算终止之日起不得少于10年。"
        },
        {
            "title": "发售QDII基金的管理人必须具备（　　）",
            "question": "A. 合格境内机构投资者资格\nB. 经营外汇业务资格\nC. 合格境内机构投资者资格和经营外汇业务资格\nD. 基金从业资格",
            "answer": "C",
            "explain": "发售QDII基金的管理人必须具备合格境内机构投资者资格和经营外汇业务资格。"
        },
        {
            "title": "下列属于道德与法律的区别的是（　　）",
            "question": "A. 调整对象不同\nB. 调整目的不同\nC. 内容结构不同\nD. 规范程度不同",
            "answer": "C",
            "explain": "道德与法律的区别主要包括：(1)表现形式不同；(2)内容结构不同；(3)调整范围不同；(4)调整手段不同。"
        },
        {
            "title": "我国开放式基金首次募集的募集期限为自该基金份额发售之日起（　　）个月内",
            "question": "A. 3\nB. 6\nC. 9\nD. 1",
            "answer": "A",
            "explain": "我国开放式基金首次募集的募集期限为自该基金份额发售之日起3个月内。"
        }, {
            "title": "下列关于基金的表述中，不正确的是（　　）",
            "question": "A. 混合基金的股票投资比例不得超过股票基金对股票投资比例的下限\nB. 收入型基金以追求稳定的经营性收入为基本目标\nC. 目前，我国的公募证券投资基金全部是公司型基金\nD. 封闭式基金的基金份额在基金合同期限内固定不变",
            "answer": "C",
            "explain": "目前，我国的基金均为契约型基金，公司型基金以美国的投资公司为代表。"
        },
        {
            "title": "下列不属于基金销售费用的是（　　）",
            "question": "A. 基金募集费用\nB. 基金申购费\nC. 基金赎回费\nD. 基金销售服务费",
            "answer": "A",
            "explain": "基金销售费用主要是指基金的申购费、赎回费和销售服务费。"
        },
        {
            "title": "督察长检查公司内部风险控制情况，应当重点关注的事项不包括（　　）",
            "question": "A. 公司资产是否安全完整，是否出现被抽逃、挪用、违规担保、冻结等情况\nB. 公司是否按照法律法规和中国证监会的规定制定和修改各项业务规章制度、业务操作流程\nC. 公司是否对各项业务制定和实施相应的风险控制制度\nD. 公司员工是否严格有效执行公司章程制度",
            "answer": "A",
            "explain": "督察长检查公司内部风险控制情况，应当重点关注的事项包括：（1）公司是否按照法律法规和中国证监会的规定制定和修改各项业务规章制度、业务操作流程；(2)公司是否对各项业务制定和实施相应的风险控制制度；(3)公司员工是否严格有效执行公司章程制度。"
        },
        {
            "title": "下列关于我国证券投资基金的表述中，不正确的是（　　）",
            "question": "A. 投资者通过购买基金份额方式直接进行证券投资\nB. 每只基金都有一个基金合同\nC. 证券投资基金是一种间接投资工具\nD. 证券投资基金通过发行份额方式间接进行证券投资",
            "answer": "A",
            "explain": "基金是一种间接投资方式，投向金融市场。投资者通过购买基金份额间接进行证券投资，而不是直接投资。"
        },
        {
            "title": "下列行为中，基金的市场营销主要涉及（　　）",
            "question": "A. 基金的信息披露\nB. 基金份额的注册登记\nC. 基金份额的募集与客户服务\nD. 基金的估值",
            "answer": "C",
            "explain": "基金的市场营销主要涉及基金份额的募集与客户服务，基金的投资管理体现了基金管理人的服务价值，而基金份额的注册登记、基金资产的估值、会计核算、信息披露等后台管理服务则会对保障基金的安全运作起着重要的作用。"
        },
        {
            "title": "对于不同的基金品种，份额登记时间可能不一样，一般基金是（　　）日登记",
            "question": "A. T\nB. T+1\nC. T+2\nD. T+3",
            "answer": "B",
            "explain": "对于不同的基金品种，份额登记时间可能不一样，一般基金是T+1登记，而QDII基金则通常是T+2日登记。"
        },
        {
            "title": "在每日开市前，基金管理人需向（　　）提供ETF的申购清单和赎回清单",
            "question": "A. III、IV\nB. I、III\nC. II、IV\nD. I、II",
            "questions": "I. 证券交易所<br>II. 证券登记结算机构<br>III. 基金托管人<br>IV.基金管理公司",
            "answer": "D",
            "explain": "在每日开市前，基金管理人需向证券交易所、证券登记结算机构提供ETF的申购、赎回清单。"
        },
        {
            "title": "基金经理人在申请期间申请材料涉及的事项发生重大变化的，基金管理人应当自发生变化之日起（　　）个工作日内向中国证监会提交更新材料",
            "question": "A. 1\nB. 3\nC. 5\nD. 10",
            "answer": "C",
            "explain": "基金经理人在申请期间申请材料涉及的事项发生重大变化的，基金管理人应当自发生变化之日起5个工作日内向中国证监会提交更新材料。"
        },
        {
            "title": "（　　）是指在目标客户中寻找有需求、有购买能力、未来有望成为现实客户的将来购买者",
            "question": "A. 客户定位\nB. 客户寻找\nC. 市场划分\nD. 市场定位",
            "answer": "B",
            "explain": "客户寻找是指在目标客户中寻找有需求、有购买能力、未来有望成为现实客户的将来购买者。"
        },
        {
            "title": "在价格策略中，基金销售机构通常采用多种费率相结合的方式，设定不同费率结构的依据不包括（　　）",
            "question": "A. 基金份额持有期限不同\nB. 申购资金量不同\nC. 基金成立时间不同\nD. 基金投资品种不同",
            "answer": "C",
            "explain": "在价格策略方面，基金销售机构常采取多种费率结构相结合的方式，根据申购资金量不同、持有期限不同、基金投资品种和期限的不同设定不同的费率结构。"
        },
        {
            "title": "关于基金和银行储蓄存款的性质，以下表述错误的是（　　）",
            "question": "A. 基金是一种受益凭证\nB. 银行对存款者负有法定的保本付息责任\nC. 基金管理人需要承担基金投资损失的风险\nD. 银行储蓄存款是一种信用凭证",
            "answer": "C",
            "explain": "基金是一种受益凭证，基金财产独立于基金管理人，基金管理人只是受托管理投资者资金，并不承担基金投资损失的风险。"
        }, {
            "title": "关于基金和银行储蓄存款的性质，以下表述错误的是（　　）",
            "question": "A. 基金是一种受益凭证\nB. 银行对存款者负有法定的保本付息责任\nC. 基金管理人需要承担基金投资损失的风险\nD. 银行储蓄存款是一种信用凭证",
            "answer": "C",
            "explain": "基金是一种受益凭证，基金财产独立于基金管理人，基金管理人只是受托管理投资者资金，并不承担基金投资损失的风险；银行储蓄存款表现为银行的负债，是一种信用凭证；银行对存款者负有法定的保本付息责任。"
        },
        {
            "title": "基金销售机构应当建立科学合理的方法，设置必要的标准和流程，保证基金销售适用性的实施。这属于基金销售适用性的（　　）原则",
            "question": "A. 专业性\nB. 客观性\nC. 全面性\nD. 规范性",
            "answer": "B",
            "explain": "基金销售适用性的客观性原则是指基金销售机构应当建立科学合理的方法，设置必要的标准和流程，保证基金销售适用性的实施。"
        },
        {
            "title": "（　　）是指每个细分市场有明显的区分标准，让销售机构能够清楚地认识不同细分市场的客户差异，提供个性化的产品和服务，以确保营销策略具有针对性",
            "question": "A. 可测原则\nB. 易入原则\nC. 利润原则\nD. 识别原则",
            "answer": "D",
            "explain": "识别原则是指每个细分市场有明显的区分标准，让销售机构能够清楚地认识不同细分市场的客户差异，提供个性化的产品和服务，以确保营销策略具有针对性。"
        },
        {
            "title": "ETF联接基金投资于目标ETF的资产不得低于联接基金资产净值的（　　）",
            "question": "A. 30%\nB. 50%\nC. 80%\nD. 90%",
            "answer": "D",
            "explain": "ETF联接基金投资于目标ETF的资产不得低于联接基金资产净值的90%。"
        },
        {
            "title": "LOF与ETF的区别不包括（　　）",
            "question": "A. 申购和赎回的标的不同\nB. 申购和赎回的场所不同\nC. 申购和赎回的时间不同\nD. 基金投资策略不同",
            "answer": "C",
            "explain": "LOF与ETF的区别有：申购和赎回的标的不同、申购和赎回的场所不同、对申购和赎回限制不同、净值报价频率不同和基金投资策略不同。"
        },
        {
            "title": "基金管理人与基金销售机构可以在基金销售协议中约定依据基金销售机构销售基金的保有量提取一定比例的（　　）",
            "question": "A. 交易手续费\nB. 交易佣金\nC. 客户维护费\nD. 客户垫付费",
            "answer": "C",
            "explain": "基金管理人与基金销售机构可以在基金销售协议中约定依据基金销售机构销售基金的保有量提取一定比例的客户维护费，用以向基金销售机构支付客户服务及销售活动中产生的相关费用。"
        },
        {
            "title": "公募基金的特征不包括（　　）",
            "question": "A. 基金募集对象不固定\nB. 投资额要求高，适宜大投资者参与\nC. 必须遵守基金法律和法规的约束\nD. 可以面向社会公众公开发售基金份额和宣传推广",
            "answer": "B",
            "explain": "公募基金的投资额要求低，适宜中小投资者参与。"
        },
        {
            "title": "申请募集公募基金应当提交的必备文件包括（　　）",
            "question": "A. 基金合同草案、基金托管协议草案、招募说明书草案、法律意见书草案\nB. 基金合同、基金合同草案、基金托管协议草案、发售公告草案、法律意见书草案\nC. 发售公告、基金合同草案、基金托管协议草案、发售公告草案、法律意见书\nD. 申请报告、基金合同草案、基金托管协议草案、招募说明书草案、法律意见书",
            "answer": "D",
            "explain": "注册公开募集基金，由拟任基金管理人向中国证监会提交下列文件：（1）申请报告；(2)基金合同草案；(3)基金托管协议草案；(4)招募说明书草案；(5)律师事务所出具的法律意见书；(6)中国证监会规定提交的其他文件。"
        },
        {
            "title": "可以作为基金管理公司实际控制人的是（　　）",
            "question": "A. 因故意犯罪被判处刑罚，刑罚执行完毕超过3年的\nB. 净资产低于实收资本的50%\nC. 不能清偿到期债务\nD. 或有负债达到净资产的50%",
            "answer": "A",
            "explain": "不得成为基金管理公司实际控制人的情形有：(1)因故意犯罪被判处刑罚，刑罚执行完毕未逾3年的；(2)净资产低于实收资本的50%，或者或有负债达到净资产的50%；(3)不能清偿到期债务。"
        },
        {
            "title": "根据基金销售适用性原则，应对（　　）做出评价",
            "question": "A. 基金管理人、基金销售机构、基金经理\nB. 基金管理人、基金产品、基金投资人\nC. 基金投资人、基金经理、基金投资策略\nD. 基金管理人、基金托管人、基金销售机构",
            "answer": "B",
            "explain": "基金销售机构应当将基金销售适用性作为内部控制的组成部分，将基金销售适用性贯穿于基金销售的各个业务环节，对基金管理人（或产品发起人）、基金产品（或基金相关产品）和基金投资人都要了解并做出评价。"
        },
        {
            "title": "对通过中国基金业协会资质考核并获得基金销售资格的基金销售人员，基金销售机构不需要为其统一办理（　　）",
            "question": "A. 后续培训\nB. 执业注册\nC. 从业证书\nD. 执业年检",
            "answer": "C",
            "explain": "基金销售机构应该建立科学的聘用、培训、考核、晋升、淘汰等人力资源管理制度，确保基金销售人员具备与岗位要求相适应的职业操守和专业胜任能力。基金销售机构对于通过基金业协会资质考核并获得基金销售资格的基金销售人员，统一办理执业注册、后续培训和执业年检。"
        }, {
            "title": "非公开基金募集完毕后，基金管理人应当向（　　）备案",
            "question": "A. 中国证监会\nB. 证券交易所\nC. 基金业协会\nD. 基金管理公司",
            "answer": "C",
            "explain": "非公开基金募集完毕后，基金管理人应当向基金业协会备案。"
        },
        {
            "title": "基金财产不能用于投资（　　）",
            "question": "A. 房地产\nB. 上市交易的债券\nC. 上市交易的股票\nD. 证监会规定的其他证券及其衍生品种",
            "answer": "A",
            "explain": "基金财产应当用于下列投资：(1)上市交易的股票、债券；(2)证监会规定的其他证券及其衍生品种。"
        },
        {
            "title": "重新召集的基金份额持有人大会应当由代表（　　）以上的基金份额持有人参加，方可召开",
            "question": "A. 1/3\nB. 1/2\nC. 2/3\nD. 3/4",
            "answer": "A",
            "explain": "重新召集的基金份额持有人大会应当由代表1/3以上的基金份额持有人参加，方可召开。"
        },
        {
            "title": "基金宣传材料可以登载该基金、基金管理人的其他基金的过往业绩，但基金合同生效不足（　　）个月的除外",
            "question": "A. 1\nB. 2\nC. 3\nD. 6",
            "answer": "D",
            "explain": "基金宣传材料可以登载该基金、基金管理人的其他基金的过往业绩，但基金合同生效不足6个月的除外。"
        },
        {
            "title": "以4Ps为核心的营销策略不包括（　　）",
            "question": "A. 产品策略\nB. 投资策略\nC. 渠道策略\nD. 价格策略",
            "answer": "B",
            "explain": "以4Ps为核心的营销策略包括：产品策略、价格策略、渠道策略和促销策略。"
        },
        {
            "title": "下列选项中，属于基金客户服务内容的是（　　）",
            "question": "A. II、III、IV\nB. I、III、IV\nC. I、II、III\nD. I、II、III、IV",
            "questions": "I. 向客户介绍客户服务、信息查询等的办法和路径<br>II. 进行基金产品未来业绩及净值预测，让客户充分了解基金投资的特点<br>III. 当基金经理、基金产品发生变动时及时通知客户<br>IV. 协助客户办理开立账户、资料变更等业务",
            "answer": "B",
            "explain": "基金销售人员不得预测所推介基金的未来业绩。"
        },
        {
            "title": "证券投资基金的作用不包括（　　）",
            "question": "A. 优化金融机构、促进经济增长\nB. 为大型投资者拓宽了投资渠道\nC. 有利于证券市场的发展和健康发展\nD. 完善金融体系和社会保障体系",
            "answer": "B",
            "explain": "B项，为中小投资者拓宽了投资渠道。"
        },
        {
            "title": "基金宣传推介材料是指（　　）",
            "question": "A. 推介基金向公众分发或者公布，使公众可以普遍获得的基金公司与代销机构签订的代理销售协议的信息\nB. 推介基金向特定客户分发或者公布，使特定客户可以获得的书面、电子或者其他介质的信息\nC. 推介基金向公众分发或者公布，使公众可以普遍获得的书面、电子或者其他介质的信息\nD. 推介基金向特定客户分发或者公布，使特定客户可以获得的基金公司与代销机构签订的代理销售协议的信息",
            "answer": "C",
            "explain": "《证券投资基金销售管理办法》规定，基金宣传推介材料是指为推介基金向公众分发或者公布，使公众可以普遍获得的书面、电子或者其他介质的信息。"
        },
        {
            "title": "（　　）是指针对陌生关系群体，是营销人员通过主动自我介绍与陌生人认识、交流，把陌生人发展成为潜在客户的方法",
            "question": "A. 缘故法\nB. 定位法\nC. 介绍法\nD. 陌生拜访法",
            "answer": "D",
            "explain": "陌生拜访法是指针对陌生关系群体，是营销人员通过主动自我介绍与陌生人认识、交流，把陌生人发展成为潜在客户的方法。"
        },
        {
            "title": "无须披露上市交易公告书的基金品种是（　　）",
            "question": "A. 上市开放式基金\nB. 封闭式基金\nC. 开放式基金\nD. 交易型开放式指数基金",
            "answer": "C",
            "explain": "目前，披露上市交易公告书的基金品种主要有封闭式基金、上市开放式基金(LOF)和交易型开放式指数基金(ETF)以及分级基金子份额。"
        }, {
            "title": "基金业协会对私募基金管理人、高级管理人员及其他从业人员的自律处分措施包括（　　）",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、II、III、IV\nD. I、III、IV",
            "questions": "I. 警告<br>II. 行业内通报批评<br>III. 公开遣责<br>IV. 取消从业资格",
            "answer": "C",
            "explain": "《私募投资基金管理人登记和基金备案办法(试行)》规定，基金业协会可以对私募基金管理人、高级管理人员及其他从业人员采取警告、行业内通报批评、公开谴责、暂停受理基金备案、取消会员资格，对高级管理人员及其他从业人员采取警告、行业内通报批评、公开谴责、取消从业资格及记入诚信档案等惩罚措施。"
        },
        {
            "title": "（　　）是指基金从业人员应当具备与其执业活动相适应的职业技能，应当具备从事相关活动所必需的专业知识和技能，并保持和提高专业胜任能力，提高风险管理能力，不得做出任何与专业胜任能力相背离的行为",
            "question": "A. 勤勉尽责\nB. 诚实守信\nC. 守法合规\nD. 专业审慎",
            "answer": "D",
            "explain": "专业审慎是指基金从业人员应当具备与其执业活动相适应的职业技能，应当具备从事相关活动所必需的专业知识和技能，并保持和提高专业胜任能力，提高风险管理能力，不得做出任何与专业胜任能力相背离的行为。"
        },
        {
            "title": "定期报告中的特殊披露要求不包括（　　）",
            "question": "A. 境外投资顾问和境外资产托管人信息\nB. 境外证券投资信息\nC. 投资交易信息\nD. 外币交易和外币折算相关的信息",
            "answer": "C",
            "explain": "QDII基金在定期报告中的特殊披露要求包括：（1）境外投资顾问和境外资产托管人信息。（2）境外证券投资信息。（3）外币交易及外币折算相关的信息。C项投资交易信息属于基金合同、基金招募说明书中的特殊披露要求。"
        },
        {
            "title": "基金经理任职应当具备的条件不包括（　　）",
            "question": "A. 取得基金从业资格\nB. 具有3年以上证券投资管理经验\nC. 通过中国证监会或者其授权机构组织的高级管理人员证券投资法律知识考试\nD. 最近2年没有受到证券、银行、工商和税务等行政管理部门的行政处罚",
            "answer": "D",
            "explain": "D项应改为最近3年没有受到证券、银行、工商和税务等行政管理部门的行政处罚。"
        },
        {
            "title": "公司（　　）是对公司章程规定的内控原则的细化和展开，是各项基本管理制度的纲要和总揽",
            "question": "A. 内部控制大纲\nB. 基本管理制度\nC. 部门规章\nD. 业务操作手册",
            "answer": "A",
            "explain": "公司内部控制大纲是对公司章程规定的内控原则的细化和展开，是各项基本管理制度的纲要和总揽，内部控制大纲应当明确内控目标、内控原则、控制环境、内控措施等内容。"
        },
        {
            "title": "销售机构向普通投资者销售产品或提供服务的，应当履行特别告知义务，以下信息属于特别告知义务范围的有（　　）",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. II、III、IV\nD. I、II、IV",
            "questions": "I. 可能直接导致本金亏损的事项<br>II. 可能直接导致超过原始本金损失的事项<br>III. 因经营机构的业务或财产状况变化，影响客户判断的重要事由<br>IV. 投资者适当性匹配意见",
            "answer": "B",
            "explain": "基金销售机构向普通投资者销售产品或者提供服务前，应当告知下列信息：（1）可能直接导致本金亏损的事项。（2）可能直接导致超过原始本金损失的事项。（3）因经营机构的业务或者财产状况变化，可能导致本金或者原始本金亏损的事项。（4）因经营机构的业务或者财产状况变化，影响客户判断的重要事由。（5）限制销售对象权利行使期限或者可解除合同期限等全部限制内容。（6）投资者适当性匹配意见。"
        },
        {
            "title": "中国证监会的职责不包括（　　）",
            "question": "A. 办理基金备案\nB. 进行基金注册登记\nC. 制定基金从业人员的资格标准和行为准则\nD. 监督检查基金信息的披露情况",
            "answer": "B",
            "explain": "中国证监会的职责有：（1）制定有关证券投资基金活动监督管理的规章、规则，并行使审批、核准或者注册权；(2)办理基金备案；(3)对基金管理人、基金托管人及其他机构从事证券投资基金活动进行监督管理，对违法行为进行查处，并予以公告；（4）制定基金从业人员的资格标准和行为准则，并监督实施；（5）监督检查基金信息的披露情况；（6）指导和监督基金业协会的活动；(7)法律、行政法规规定的其他职责。"
        },
        {
            "title": "对于短期交易而言，对持续持有期少于7日的投资人收取不低于赎回金额（　　）的赎回费用",
            "question": "A. 1.0%\nB. 1.5%\nC. 2%\nD. 0.75%",
            "answer": "B",
            "explain": "对持续持有期少于7日的投资人收取不低于1.5%的赎回费，对持续持有期少于30日的投资人收取不低于0.75%的赎回费。"
        },
        {
            "title": "（　　）加入基金业协会的，为联席会员",
            "question": "A. 基金管理人\nB. 基金服务机构\nC. 证券期货交易所\nD. 地方基金业协会",
            "answer": "B",
            "explain": "基金服务机构加入基金业协会的，为联席会员。"
        },
        {
            "title": "根据合规管理的要求，基金公司在日常业务活动中应当遵守（　　）",
            "question": "A. I、II、IV\nB. I、II\nC. II、III、IV\nD. I、II、III、IV",
            "questions": "I. 基本法律规则<br>II. 适用于全行业的规范、标准、惯例等<br>III. 公司章程<br>IV. 职业道德",
            "answer": "D",
            "explain": ""
        }, {
            "title": "基金管理人的合规管理可以定义为（　　）",
            "question": "A. 对基金管理人的相关业务是否遵循法律、监管规定、规则、自律性组织制定的有关准则以及公众投资者的基本需求等行为进行风险识别、检查、通报、评估、处置的管理活动\nB. 对基金管理人的相关业务是否遵循法律、监管规定、规则、自律性组织制定的有关准则以及公众投资者的基本需求等行为进行风险识别、检查、通报、评估、处置的管理活动\nC. 对基金管理人的相关业务是否遵循法律、监管规定、规则、自律性组织制定的有关准则以及公众投资者的基本需求等行为进行风险识别、检查、通报、评估、处置的管理活动\nD. 对基金管理人的相关业务是否遵循法律、监管规定、规则、自律性组织制定的有关准则以及公众投资者的基本需求等行为进行风险识别、检查、通报、评估、处置的管理活动",
            "answer": "D",
            "explain": "基金管理人的合规管理可以定义为‘对基金管理人的相关业务是否遵循法律、监管规定、规则、自律性组织制定的有关准则以及公众投资者的基本需求等行为进行风险识别、检查、通报、评估、处置的管理活动’。上述相关规则包括：立法机关和中国证监会发布的基本法律规则；基金业协会和证券业协会等自律性组织制定的适用于全行业的规范、标准、惯例等；公司章程以及企业的各种内部规章制度以及应当遵守的诚实、守信的职业道德。"
        },
        {
            "title": "设立基金管理公司，股东应当具有经营金融业务或者管理金融机构的良好业绩、良好的财务状况和社会信誉，最近（　　）年没有违法记录",
            "question": "A. 半\nB. 1\nC. 2\nD. 3",
            "answer": "D",
            "explain": "设立基金管理公司，股东应当具有经营金融业务或者管理金融机构的良好业绩、良好的财务状况和社会信誉，资产规模达到国务院规定的标准，最近3年没有违法记录。"
        },
        {
            "title": "下列关于封闭式基金和开放式基金在投资策略方面差异的说法中，错误的是（　　）",
            "question": "A. 封闭式基金有约定的封闭期，可按照预先设定的计划进行长期投资\nB. 开放式基金的基金资产可全额投资于流动性较弱而预期收益较高的证券\nC. 封闭式基金通常在流动性管理上面临的压力较小\nD. 开放式基金需要考虑赎回对投资策略的影响",
            "answer": "B",
            "explain": "相对而言，由于封闭式基金份额固定，没有赎回压力，基金投资管理人员完全可以根据预先设定的投资计划进行长期投资和全额投资，并将基金资产投资于流动性相对较弱的证券上，这在一定程度上有利于基金长期业绩的提高。"
        },
        {
            "title": "关于基金销售适用性的实施保障，以下表述正确的是（　　）",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、II、III、IV",
            "questions": "I. 基金销售机构总部应当建立销售的基金产品<br>II. 基金销售机构应当就基金销售适用性的理论和实践对基金销售人员实行专题培训<br>III. 在销售业务信息管理平台中建设并维护与基金销售适用性相关的功能模块<br>IV. 基金销售分支机构应在总部的指导和管理下实施与基金销售适用性相关的制度和程序",
            "answer": "D",
            "explain": "基金销售机构总部应当负责制定与基金销售适用性相关的制度和程序，建立销售的基金产品池，在销售业务信息管理平台中建设并维护与基金销售适用性相关的功能模块。基金销售机构分支机构应当在总部的指导和管理下实施与基金销售适用性相关的制度和程序。基金销售机构应当就基金销售适用性的理论和实践对基金销售人员实行专题培训。"
        },
        {
            "title": "甲有1000元闲置资金，希望通过投资实现保值增值，但1000元最多只能购买1、2只股票，因此甲选择购买沪深300指数基金，甲的选择是因为基金具有以下特点（　　）",
            "question": "A. 利益共享、风险共担\nB. 严格监管、信息透明\nC. 组合投资、分散风险\nD. 独立托管、保障安全",
            "answer": "C",
            "explain": "为降低投资风险，一些国家的法律法规规定基金除另有规定外，一般须以组合投资的方式进行投资运作，从而使‘组合投资、分散风险’成为基金的一大特色。中小投资者由于资金量小，一般无法通过购买数量众多的股票分散投资风险。基金通常会购买几十种甚至上百种股票，投资者购买基金就相当于用很少的资金购买了一篮子股票。"
        },
        {
            "title": "当公司运作中存在问题时，下列不属于督察长可以行使的权利是（　　）",
            "question": "A. 及时告知公司总经理和相关业务负责人，提出处理意见和整改建议\nB. 对公司运作中存在的问题进行善后工作\nC. 监督整改措施的制定和落实\nD. 基金公司总经理对存在不整改或者整改未达到要求的，督察长应当向公司董事会、中国证监会及相关派出机构报告",
            "answer": "B",
            "explain": "督察长发现基金及公司运作中存在问题时，应当及时告知公司总经理和相关业务负责人，提出处理意见和整改建议，并监督整改措施的制定和落实；基金公司总经理对存在不整改或者整改未达到要求的，督察长应当向公司董事会、中国证监会及相关派出机构报告。"
        },
        {
            "title": "基金托管人召集基金份额持有人大会的，应至少提前（　　）日公告大会的召开时间、会议形式、审议事项、议事程序和表决方式等事项",
            "question": "A. 7\nB. 30\nC. 60\nD. 90",
            "answer": "B",
            "explain": "基金托管人召集基金份额持有人大会的，应至少提前30日公告大会的召开时间、会议形式、审议事项、议事程序和表决方式等事项。"
        },
        {
            "title": "对于变更公司的实际控制人，或者变更其他重大事项的基金管理公司，国务院证券监督管理机构应当自受理其申请之日起（　　）日内作出批准或者不予批准的决定",
            "question": "A. 15\nB. 30\nC. 45\nD. 60",
            "answer": "D",
            "explain": "基金管理公司变更持有5%以上的股权的股东，变更公司的实际控制人，或者变更其他重大事项，国务院证券监督管理机构应当自受理其申请之日起60日内作出批准或者不予批准的决定。"
        },
        {
            "title": "（　　）是我国对证券投资基金的一种本土化创新",
            "question": "A. 系列基金\nB. ETF\nC. 避险策略基金\nD. LOF",
            "answer": "D",
            "explain": "上市开放式基金(LOF)是一种既可以在场外市场进行基金份额申购、赎回，又可以在交易所(场内市场)进行基金份额交易和基金份额申购或赎回的开放式基金。它是我国对证券投资基金的一种本土化创新。"
        }, {
            "title": "当货币市场基金管理人正偏离度绝对值达到0.50%时，基金管理人应当暂停接受申购并在5个交易日内将正偏离度绝对值调整到（　　）以内",
            "question": "A. 0.20%\nB. 0.50%\nC. 0.25%\nD. 0.40%",
            "answer": "B",
            "explain": "当正偏离度绝对值达到0.5%时，基金管理人应当暂停接受申购并在5个交易日内将正偏离度绝对值调整到0.5%以内。"
        },
        {
            "title": "下列关于证券投资基金概念的表述，正确的是（　　）",
            "question": "A. I、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II、IV",
            "questions": "I. 基金管理人按照基金的资产规模获得一定比率的管理费收入<br>II. 证券投资基金是投资人直接通过分散投资的一种投资方式<br>III. 证券投资基金的投资人共享投资收益，共担投资风险<br>IV. 证券投资基金的资产独立于管理人和托管人的资产",
            "answer": "A",
            "explain": "从本质上来说，证券投资基金是一种间接通过基金管理人代理投资的一种方式，投资人通过基金管理人的专业资产管理，以期得到比自行管理更高的报酬。"
        },
        {
            "title": "基金合同的主要内容中不包括（　　）",
            "question": "A. 基金收益分配原则、执行方式\nB. 基金风险揭示\nC. 基金管理人、基金托管人的名称和住所\nD. 基金财产的投资方向和投资限制",
            "answer": "B",
            "explain": "ACD项属于基金合同的主要内容。"
        },
        {
            "title": "下列不属于基金服务提供的方式的是（　　）",
            "question": "A. 电话服务中心\nB. 邮寄服务\nC. 上门服务\nD. 互联网的应用",
            "answer": "C",
            "explain": "基金服务提供的方式通常包括：电话服务中心、邮寄服务、自动传真、电子信箱与手机短信、‘一对一’专人服务、互联网的应用、媒体和宣传手册的应用、讲座、推介会和座谈会、微信和移动客户端的应用。"
        },
        {
            "title": "守法合规是基金从业人员职业道德的基础要求，基金从业人员守法合规的目的包括（　　）",
            "question": "A. I、II、III、IV\nB. I、III\nC. I、II、III\nD. I、III、IV",
            "questions": "I. 避免实施违法违规行为<br>II. 与监管机构共同制定监督政策<br>III. 避免参与他人实施的违法违规行为<br>IV. 参与监管机构的执法活动",
            "answer": "B",
            "explain": "守法合规的目的是避免基金从业人员自己实施或者参与违法违规的行为，或者为他人违法违规的行为提供帮助。"
        },
        {
            "title": "下列关于基金管理人对开放式基金巨额赎回的处理方式的说法中，正确的是（　　）",
            "question": "A. I、II、III\nB. II、III\nC. I、II\nD. I、II、III、IV",
            "questions": "I. 避免实施违法违规行为<br>II. 与监管机构共同制定监督政策<br>III. 避免参与他人实施的违法违规行为<br>IV. 参与监管机构的执法活动",
            "answer": "C",
            "explain": "基金连续2个开放日以上发生巨额赎回，如基金管理人认为有必要，可暂停接受赎回申请；已经接受的赎回申请可以延缓支付赎回款项，但不得超过正常支付时间20个工作日，并应当在至少一种中国证监会指定的信息披露媒体公告。"
        },
        {
            "title": "开放式基金非交易过户不包括（　　）",
            "question": "A. 捐赠\nB. 继承\nC. 司法强制执行\nD. 转换",
            "answer": "D",
            "explain": "开放式基金非交易过户是指不采用申购、赎回等基金交易方式，将一定数量的基金份额按照一定规则从某一投资者基金账户转移到另一投资者基金账户的行为，主要包括继承、捐赠、司法强制执行等方式。"
        },
        {
            "title": "（　　）能有效分散风险，是一种风险相对集中、收益相对稳健的投资品种",
            "question": "A. 股票\nB. 债券\nC. 金融衍生工具\nD. 基金",
            "answer": "D",
            "explain": "基金可以投资于众多的金融工具或产品，能有效分散风险，是一种风险相对集中、收益相对稳健的投资品种。"
        },
        {
            "title": "（　　）主要依赖于金融衍生产品，实现投资组合价值的保本与增值",
            "question": "A. 对冲保险策略\nB. 对冲投资策略\nC. 固定比例投资组合保险策略\nD. 浮动比例投资组合保险策略",
            "answer": "A",
            "explain": "对冲保险策略主要依赖于金融衍生产品，如股票期权、股指期货等，实现投资组合价值的保本与增值。"
        }, {
            "title": "向特定对象募集资金累计超过（　　）人称为公开募集基金",
            "question": "A. 50\nB. 100\nC. 150\nD. 200",
            "answer": "D",
            "explain": "公开募集基金包括向不特定对象募集资金、向特定对象募集资金累计超过200人，以及法律、行政法规规定的其他情形。"
        },
        {
            "title": "基金份额通常在（　　）万元以上才能参与ETF的申购、赎回交易",
            "question": "A. 10\nB. 20\nC. 30\nD. 50",
            "answer": "D",
            "explain": "基金份额通常在50万元以上才能参与ETF的申购、赎回交易。"
        },
        {
            "title": "封闭式基金上市交易条件包括（　　）",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、III、IV",
            "questions": "I. 基金合同期限5年以上<br>II. 基金募集资金不低于2亿元<br>III. 基金投资者人数不少于1000人<br>IV. 公司自有资金认购金额不低于1000万元",
            "answer": "B",
            "explain": "封闭式基金份额上市交易，应当符合下列条件：基金的募集符合《证券投资基金法》规定；基金合同期限为5年以上；基金募集金额不低于2亿元人民币；基金份额持有人不少于1000人；基金份额上市交易规则规定的其他条件。"
        },
        {
            "title": "2019年2月18日，某投资者通过场外（某银行）申购该基金30000元，当日基金份额净值为1.05元，则其申购手续费和可得到的申购份额分别为（　　）",
            "question": "A. 450元和28142.86份\nB. 443.34元和29556.65份\nC. 443.35元和28149.19份\nD. 450元和29550份",
            "answer": "C",
            "explain": "申购费用 = 申购金额 - 申购金额 / (1 + 申购费率) = 30000 - 30000 / (1 + 1.5%) = 443.35元，申购份额 = 30000 / (1 + 1.5%) / 1.05 = 28149.19份。"
        },
        {
            "title": "2019年7月18日，该投资者赎回该基金份额10000份，持有时间为5个月，赎回当日基金份额净值为1.00元，则其赎回手续费和可得到的赎回金额分别为（　　）",
            "question": "A. 50元和9950元\nB. 54.73元和10945元\nC. 55元和10945元\nD. 49.75元和9950.25元",
            "answer": "A",
            "explain": "赎回总额 = 10000 × 1 = 10000元，赎回费用 = 10000 × 0.5% = 50元，赎回金额 = 10000 - 50 = 9950元。"
        },
        {
            "title": "2019年10月18日，该投资者赎回该基金份额10000份，假设赎回当日基金份额净值为1.148元，则其可得净赎回金额和基金资产的赎回费分别为（　　）",
            "question": "A. 11471.25元和28.75元\nB. 10000元和25元\nC. 11422.6元和57.4元\nD. 11471.25元和7.19元",
            "answer": "C",
            "explain": "赎回总金额 = 10000 × 1.148 = 11480元，赎回费用 = 11480 × 0.5% = 57.4元，净赎回金额 = 11480 - 57.4 = 11422.6元。"
        },
        {
            "title": "下列（　　）不是认购ETF份额的投资者采用的方式",
            "question": "A. 份额认购\nB. 场内现金认购\nC. 场外现金认购\nD. 证券认购",
            "answer": "A",
            "explain": "投资者一般可选择场内现金认购、场外现金认购以及证券认购等方式认购ETF份额。"
        }, {
            "title": "ETF二级市场交易价格与（　　）总是比较接近",
            "question": "A. 基金份额净值\nB. 基金份额总值\nC. 市场价格\nD. 交易价格",
            "answer": "A",
            "explain": "ETF二级市场交易价格与基金份额净值总是比较接近。"
        },
        {
            "title": "投资者赎回基金份额成功后，登记机关一般在（　　）日为投资者办理扣除权益的登记手续",
            "question": "A. T\nB. T+1\nC. T+2\nD. T+3",
            "answer": "B",
            "explain": "投资者赎回基金份额成功后，登记机关一般在T+1日为投资者办理扣除权益的登记手续。"
        },
        {
            "title": "下列不属于基金管理公司内部控制制度组成部分的是（　　）",
            "question": "A. 基本管理制度\nB. 内部控制大纲\nC. 部门业务规章\nD. 法律规范",
            "answer": "D",
            "explain": "基金管理公司内部控制制度由内部控制大纲、基本管理制度、部门业务规章等部分组成。"
        },
        {
            "title": "下列关于开放式股票基金的说法，错误的是（　　）",
            "question": "A. 开放式股票基金的价格在每一交易日内始终处于变化之中\nB. 与其他类型基金相比，股票基金的风险较高，但预期收益也较高\nC. 股票基金每天只进行一次净值计算，因此每一交易日只有一个价格\nD. 股票型基金80%以上的资产为股票资产",
            "answer": "A",
            "explain": "股票价格在每一个交易日内始终处于变动之中，股票基金份额净值的计算每天只进行1次，因此每一交易日股票基金只有一个价格。"
        },
        {
            "title": "公募基金行业规范的内容不包括（　　）",
            "question": "A. 信息披露\nB. 投资者的投资能力\nC. 利润分配\nD. 投资限制",
            "answer": "B",
            "explain": "公募基金一般在法律和监管部门的严格监管下，有着信息披露、利润分配、投资限制等行业规范。私募基金对投资者的投资能力有一定的要求。"
        },
        {
            "title": "QDII基金定期报告中的特殊披露要求有（　　）",
            "question": "A. I、III、IV\nB. II、III、IV\nC. I、II、III\nD. III、IV",
            "questions": "I. 境外投资顾问和境外资产托管人信息<br>II. 境外证券投资信息<br>III. 外币交易及外币折算相关的信息<br>IV. 投资顾问主要负责人变动信息",
            "answer": "C",
            "explain": "QDII基金定期报告中的特殊披露要求包括：(1)境外投资顾问和境外资产托管人信息；(2)境外证券投资信息；(3)外币交易及外币折算相关的信息。"
        },
        {
            "title": "从事私募基金业务的原则有（　　）",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III、IV\nD. I、II、III",
            "questions": "I. 自愿原则<br>II. 诚实信用原则<br>III. 收益确定原则<br>IV. 公平原则",
            "answer": "B",
            "explain": "基金管理人、基金托管人在管理、运用基金财产，从事证券投资基金活动时，应当遵循自愿、公平、诚实信用的原则，不得损害国家利益和社会公共利益。"
        },
        {
            "title": "不可以召集基金份额持有人大会的是（　　）",
            "question": "A. 基金管理人\nB. 基金托管人\nC. 代表基金份额10%以上的基金份额持有人\nD. 基金监管部门",
            "answer": "D",
            "explain": "基金份额持有人大会设立日常机构的，由该日常机构召集；该日常机构未召集的，由基金管理人召集。基金管理人未按规定召集或者不能召集的，由基金托管人召集。代表基金份额10%以上的基金份额持有人就同一事项要求召开基金份额持有人大会，而基金份额持有人大会的日常机构、基金管理人、基金托管人都不召集的，代表基金份额10%以上的基金份额持有人有权自行召集，并报中国证监会备案。"
        },
        {
            "title": "基金销售机构建立基金销售适用性管理制度，应当至少包括（　　）",
            "question": "A. I、II、III、IV\nB. II、III、IV\nC. II、III\nD. I、II、III",
            "questions": "I. 对基金管理人进行审慎调查的方式和方法<br>II. 对基金产品的风险等级进行设置<br>III. 对基金投资人风险承受能力进行调查和评价的方式和方法<br>IV. 对基金产品和基金投资人进行匹配的方法",
            "answer": "A",
            "explain": "基金销售机构应当建立基金销售适用性管理制度，至少包括以下内容：(1)对基金管理人进行审慎调查的方式和方法；(2)对基金产品的风险等级进行设置、对基金产品进行风险评价的方式和方法；(3)对基金投资人风险承受能力进行调查和评价的方式和方法；(4)对基金产品和基金投资人进行匹配的方法。"
        },
        {
            "title": "下列不属于基金管理人和托管人权利义务和职责的是（　　）",
            "question": "A. 支付申购赎回费\nB. 安全保管基金财产\nC. 投资运作管理\nD. 基金份额净值计算",
            "answer": "A",
            "explain": "基金托管协议是基金管理人和基金托管人签订的协议，主要目的在于明确双方在基金财产保管、投资运作、净值计算、收益分配、信息披露及相互监督等事宜中的权利、义务及职责，确保基金财产的安全，保护基金份额持有人的合法权益。"
        }, {
            "title": "各证监局对经营所在地在本辖区内的基金管理公司的日常监管内容，不包括（　　）",
            "question": "A. 基金托管人员的日常监管\nB. 开放式基金信息披露的日常监管\nC. 公司治理和内部控制的日常监管\nD. 基金代销机构的日常监管",
            "answer": "A",
            "explain": "各证监局负责对经营所在地在本辖区内的基金管理公司进行日常监管，主要包括公司治理和内部控制、高级管理人员、基金销售行为、开放式基金信息披露的日常监管、对辖区内异地基金管理公司的分支机构及基金代销机构进行日常监管。"
        },
        {
            "title": "关于LOF与ETF的特征，下列描述错误的是（　　）",
            "question": "A. ETF与投资者交换的是基金份额与一篮子股票\nB. LOF和ETF通常为主动管理型基金\nC. LOF与ETF都具备开放式基金可以申购、赎回和场内交易的特点\nD. LOF的申购和赎回只能是基金份额与现金对价",
            "answer": "B",
            "explain": "ETF与LOF的基金投资策略不同。ETF通常采用完全被动式管理方法，以拟合某一个指数为目标；而LOF则是普通的开放式基金增加了交易所的交易方式，它可以是指数型基金，也可以是主动管理型基金。"
        },
        {
            "title": "投资者可通过ETF进行套利交易，这主要是由于ETF具有（　　）的特点",
            "question": "A. 是被动操作指数基金\nB. 只能通过交易所进行交易\nC. 独特的实物申购、赎回机制\nD. 实行一级市场与二级市场并存的交易制度",
            "answer": "D",
            "explain": "ETF的独特之处在于实行一级市场与二级市场交易同步进行的制度安排。因此投资者可以在ETF二级市场交易价格与基金份额净值两者之间存在差价时进行套利交易。"
        },
        {
            "title": "基金投资顾问机构及其从业人员的法定义务不包括（　　）",
            "question": "A. 向投资人充分揭示投资风险\nB. 对其服务能力和经营业绩进行如实陈述\nC. 不得以任何方式承诺或者保证投资收益\nD. 不得损害服务对象的合法权益",
            "answer": "A",
            "explain": "A项属于基金销售机构的法定义务。"
        },
        {
            "title": "关于基金管理公司风险管理的目标，下列表述错误的是（　　）",
            "question": "A. 自觉形成守法经营、规范运作的经营思想和经营风格\nB. 有效维护公司股东及基金投资者利益\nC. 在风险最大化的前提下，确保基金投资人利益最大化\nD. 将风险管理纳入各部门和所有员工年度绩效考核范围",
            "answer": "C",
            "explain": "基金公司风险管理的目标可以概括为下列几个方面：（1）自觉形成守法经营、规范运作的经营思想和经营风格；（2）维护基金投资人的利益，在风险最小化的前提下，确保基金份额持有人利益最大化；（3）有效维护公司股东及基金投资者的利益；（4）建立行之有效的风险控制制度，确保公司各项业务的顺利运行；（5）维护公司信誉，树立良好的公司形象，及时、高效地配合监管部门的工作。"
        },
        {
            "title": "基金行政监管应当具有全面性，下列不属于行政监管范围的是（　　）",
            "question": "A. 各种基金机构的设立、变更和终止\nB. 为基金机构提供法律服务的律师事务所\nC. 基金机构从业人员的资格和行为\nD. 基金机构证券投资决策的正确性",
            "answer": "D",
            "explain": "广义的基金监管是指有法定监管权的行政机构、基金行业自律组织、基金机构内部监督部门以及社会力量对基金市场、基金市场主体及其活动的监督或管理。狭义的基金监管，一般专指行政监管。基金行政监管内容具有全面性，不仅涉及各种基金机构的设立、变更和终止，基金机构从业人员的资格和行为，基金机构的活动规则，而且还涉及基金市场其他诸多方面的监管。"
        },
        {
            "title": "当影子定价与摊余成本法确定的基金资产净值偏离度的绝对值超过0.5%时，基金管理人将在事件发生之日起（　　）日内就此事项进行临时报告",
            "question": "A. 1\nB. 2\nC. 3\nD. 5",
            "answer": "B",
            "explain": "当影子定价与摊余成本法确定的基金资产净值偏离度的绝对值超过0.5%时，基金管理人将在事件发生之日起2日内就此事项进行临时报告。"
        },
        {
            "title": "关于基金行业的主要参与者，下列表述错误的是（　　）",
            "question": "A. 基金市场上各类中介服务机构受管理人委托，通过自己的专业服务参与基金市场\nB. 基金托管人对基金投资运作进行监督\nC. 基金投资者、基金管理人、基金销售机构是基金的当事人\nD. 监管机构对基金市场上的各种参与主体实施监管",
            "answer": "C",
            "explain": "我国的证券投资基金依据基金合同设立，基金份额持有人、基金管理人与基金托管人是基金合同的当事人。"
        },
        {
            "title": "规范性原则、易解性原则和易得性原则属于信息（　　）应遵循的要求",
            "question": "A. 披露内容\nB. 披露形式\nC. 披露时间\nD. 披露地点",
            "answer": "B",
            "explain": "对信息披露的原则，在披露形式上应遵循规范性原则、易解性原则和易得性原则。"
        },
        {
            "title": "基金市场营销的特殊性不包括（　　）",
            "question": "A. 专业性\nB. 规范性\nC. 服务性\nD. 安全性",
            "answer": "D",
            "explain": "证券投资基金属于金融服务行业，其市场营销不同于有形产品营销，在运用4Ps理论时有其特殊性，具体包括规范性、服务性、专业性、持续性和适用性。"
        }, {
            "title": "基金监管活动的自律规则不包括（　　）",
            "question": "A. 《私募投资基金管理人登记和基金备案办法（试行）》\nB. 《基金经理注册登记规则》\nC. 《证券投资基金管理公司管理办法》\nD. 《基金从业人员证券投资管理指引（试行）》",
            "answer": "C",
            "explain": "《证券投资基金管理公司管理办法》属于基金监管部门规章和规范性文件。"
        },
        {
            "title": "下列关于基金宣传推介材料的原则性要求的说法中，正确的是（　　）",
            "question": "A. I、II、IV\nB. I、II、III、IV\nC. I、II、III\nD. I、III、IV",
            "questions": "I. 内容的合规性，与基金合同的一致性<br>II. 加强对投资者的教育和引导，培养长期投资理念<br>III. 为保护投资者利益，应披露完整的基金业绩数据<br>IV. 应引用专业人士准确的推荐评价报告",
            "answer": "C",
            "explain": "基金宣传推介材料禁止登载单位或者个人的推荐性文字。"
        },
        {
            "title": "职业的形成经历了漫长的过程，人们在长期的职业实践中形成了比较稳定的职业作风、职业素养和职业心理，会在本职工作中世代传承，从而使得同行业内形成相似的职业道德规范，体现了职业道德的（　　）",
            "question": "A. 连续性\nB. 特殊性\nC. 规范性\nD. 继承性",
            "answer": "D",
            "explain": "职业道德具有继承性，它表现在职业的形成是一个漫长的历史过程，人们在长期的职业实践中所形成的比较稳定的职业作风、职业习惯和职业心理，会在本职业中世代传承，从而使得同行业内形成相似的职业道德规范。"
        },
        {
            "title": "下列不属于基金从业人员在执业活动中接触到的秘密的是（　　）",
            "question": "A. 商业秘密\nB. 从业人员资料\nC. 客户资料\nD. 内幕信息",
            "answer": "B",
            "explain": "基金从业人员在执业活动中接触到的秘密主要包括三类：(1)商业秘密；(2)客户资料；(3)内幕信息。"
        },
        {
            "title": "以下不属于基金法定信息披露范围的是（　　）",
            "question": "A. 基金投资预测说明书\nB. 基金托管协议\nC. 基金招募说明书\nD. 基金合同",
            "answer": "A",
            "explain": "公开披露的基金信息包括：基金招募说明书、基金合同、基金托管协议、基金募集情况、基金份额上市交易公告书、基金资产净值、基金份额净值、基金份额申购赎回价格、基金财产的资产组合季度报告、财务会计报告及中期和年度基金报告、临时报告、基金份额持有人大会决议、基金管理人和基金托管人的重大人事变动等。"
        },
        {
            "title": "基金管理人的合规管理部门实施的合规风险评估和测试，包括（　　）",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、III、IV\nD. I、II、IV",
            "questions": "I. 通过现场审核对各项政策和程序的合规性进行测试<br>II. 询问政策和程序存在的缺陷并进行相应调查<br>III. 合规性测试结果通过合规风险报告路线向上报告<br>IV. 所有合规性测试结果最终需要报告中国证监会派出机构",
            "answer": "A",
            "explain": "合规管理部门应当实施充分且有代表性的合规风险评估和测试，包括通过现场审核对各项政策和程序的合规性进行测试，询问政策和程序存在的缺陷，并进行相应的调查，合规性测试结果应按照基金管理人的内部风险管理程序，通过合规风险报告路线向上报告，以确保各项政策和程序符合法律、规则和准则的要求。"
        },
        {
            "title": "基金管理人向中国证监会派出机构备案的基金宣传推介材料的报送内容包括（　　）",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、II\nD. II、III、IV",
            "questions": "I. 基金宣传推介材料的形式和用途说明<br>II. 基金宣传推介材料<br>III. 基金管理公司督察长出具的合规意见书<br>IV. 基金托管银行出具的基金业绩复核函或基金定期报告中相关内容的复印件",
            "answer": "B",
            "explain": "基金宣传推介材料的报送内容包括基金宣传推介材料的形式和用途说明、基金宣传推介材料、基金管理公司督察长出具的合规意见书、基金托管银行出具的基金业绩复核函或基金定期报告中相关内容的复印件，以及有关获奖证明的复印件。基金管理公司或基金代销机构负责基金营销业务的高级管理人员也应当对基金宣传推介材料的合规性进行复核并出具复核意见。"
        },
        {
            "title": "基金管理人应当在基金半年度报告和基金年度报告中披露的内容不包括（　　）",
            "question": "A. 从基金财产中计提的销售服务费金额\nB. 从基金财产中计提的管理费金额\nC. 从基金财产中计提的托管费金额\nD. 基金销售费用金额",
            "answer": "D",
            "explain": "基金管理人应当在基金半年度报告和基金年度报告中披露从基金财产中计提的管理费、托管费、基金销售服务费的金额，并说明管理费中支付给基金销售服务费的客户维护费总额。"
        },
        {
            "title": "我国开放式基金注册登记的模式不包括（　　）",
            "question": "A. 基金管理人自建注册登记的'内置'模式\nB. 委托中国证券登记结算有限责任公司作为注册登记机构的'外置'模式\nC. 基金管理人自建注册登记体系的'静态'模式\nD. '内置'和'外置'的混合模式",
            "answer": "C",
            "explain": "我国开放式基金注册登记体系的模式包括基金管理人自建注册登记的'内置'模式，委托中国证券登记结算有限责任公司作为注册登记机构的'外置'模式和两者情况兼有的'混合'模式。"
        }, {
            "title": "为了进一步保障基金信息质量，法规规定基金年度报告应经（　　）以上独立董事签字同意",
            "question": "A. 1/3\nB. 1/2\nC. 2/3\nD. 3/4",
            "answer": "C",
            "explain": "为了进一步保障基金信息质量，法规规定基金年度报告应经2/3以上独立董事签字同意，并由董事长签发。"
        },
        {
            "title": "公开募集基金的基金管理人及其董事、监事、高级管理人员和其他从业人员可以有下列（　　）行为",
            "question": "A. 不公平地对待其管理的不同基金财产\nB. 向基金份额持有人承诺收益或者承担损失\nC. 按照基金合同的约定确定基金收益分配方案，及时向基金份额持有人分配收益\nD. 侵占、挪用基金财产",
            "answer": "C",
            "explain": "公开募集基金的基金管理人及其董事、监事、高级管理人员和其他从业人员不得有下列行为：将固有财产或者他人财产混同于基金财产从事证券投资；不公平地对待其管理的不同基金财产；利用基金财产或者职务之便为基金份额持有人以外的人牟取利益；向基金份额持有人违规承诺收益或者承担损失；侵占、挪用基金财产；泄露因职务便利获取的未公开信息，利用该信息从事或者明示、暗示他人从事相关的交易活动；玩忽职守，不按照规定履行职责；法律、行政法规和国务院证券监督管理机构规定禁止的其他行为。"
        },
        {
            "title": "以下（　　）类型的混合基金中股票与债券的配置比例通常为40%~60%",
            "question": "A. 股债平衡型基金\nB. 偏股型基金\nC. 偏债型基金\nD. 灵活配置型基金",
            "answer": "A",
            "explain": "股债平衡型基金股票与债券的配置比例较为均衡，其业绩比较基准也会以股票指数和债券指数大致均衡组合。"
        },
        {
            "title": "（　　）是指通过事先约定基金的风险收益分配，将母基金份额分为预期风险收益不同的子份额，并可将其中部分或全部类别份额上市交易的结构化证券投资基金",
            "question": "A. 避险策略基金\nB. 混合基金\nC. 债券基金\nD. 分级基金",
            "answer": "D",
            "explain": "分级基金是指通过事先约定基金的风险收益分配，将母基金份额分为预期风险收益不同的子份额，并可将其中部分或全部类别份额上市交易的结构化证券投资基金。"
        },
        {
            "title": "基金份额登记机构妥善保存登记数据，并将基金份额持有人名称、身份信息及基金份额明细等数据备份至中国证监会指定的机构，其保存期限自基金账户销户之日起不得少于（　　）年",
            "question": "A. 3\nB. 5\nC. 10\nD. 20",
            "answer": "D",
            "explain": "基金份额登记机构要妥善保存登记数据，并将基金份额持有人名称、身份信息及基金份额明细等数据备份至中国证监会指定的机构。其保存期限自基金账户销户之日起不得少于20年。"
        },
        {
            "title": "关于非公开募集基金管理人登记的描述，下列错误的是（　　）",
            "question": "A. 降低了非公开募集基金管理人的设立难度和设立成本\nB. 体现了国家对公开募集基金和非公开募集基金区别监管的理念\nC. 实行自律管理有利于非公开募集基金的灵活运作\nD. 中国证券投资基金业协会依据中国证监会的授权对非公开募集基金管理人进行统一监管",
            "answer": "D",
            "explain": "我国对于非公开募集基金的基金管理人没有严格的市场准入限制，担任非公开募集基金的基金管理人无须中国证监会审批，而实行登记制度，即非公开募集基金的基金管理人只需向基金业协会登记即可。对于非公开募集基金管理人的内部治理结构也没有强制性的监管要求，而由基金业协会制定相关指引和准则，实行自律管理。这降低了非公开募集基金管理人的设立难度和设立成本，也有利于非公开募集基金灵活运作，体现了区别监管的理念。"
        },
        {
            "title": "基金托管人发现基金管理人的投资指令违反基金合同时，正确的做法是（　　）",
            "question": "A. 拒绝执行，立即通知基金管理人，并及时向中国证监会报告\nB. 通知基金管理人后再执行投资指令\nC. 通知基金持有人并按其要求处理\nD. 执行投资指令后立即报告中国证监会",
            "answer": "A",
            "explain": "基金托管人发现基金管理人的投资指令违反法律、行政法规和其他有关规定，或者违反基金合同约定的，应当拒绝执行，立即通知基金管理人，并及时向中国证监会报告。"
        },
        {
            "title": "基金财产可以参与的投资和活动是（　　）",
            "question": "A. 从事内幕交易、操纵证券交易价格及其他不正当的证券交易活动\nB. 违反规定向他人贷款或者提供担保\nC. 从事承担有限责任的投资\nD. 向基金管理人、托管人出资",
            "answer": "C",
            "explain": "基金财产不得用于的投资或活动包括：(1)承销证券；(2)违反规定向他人贷款或者提供担保；(3)从事承担无限责任的投资；(4)买卖其他基金份额，但是中国证监会另有规定的除外；(5)向基金管理人、托管人出资；(6)从事内幕交易、操纵证券交易价格及其他不正当的证券交易活动；(7)法律、行政法规和中国证监会规定禁止的其他活动。"
        },
        {
            "title": "私募基金管理人推介其产品，以下做法合规的是（　　）",
            "question": "A. 销售人员按照公司提供的大客户名单一对一介绍公司新产品\nB. 销售人员在五星级酒店前台摆放介绍公司产品的易拉宝\nC. 销售人员在自己的微信朋友圈里推送公司产品介绍\nD. 销售人员在银行高净值客户见面会上推介产品",
            "answer": "A",
            "explain": "募集机构不得通过下列媒介渠道推介私募基金：①公开出版资料；②面向社会公众的宣传单、布告、手册、信函、传真；③海报、户外广告；④电视、电影、电台及其他音像等公共传播媒体；⑤公共、门户网站链接广告、博客等；⑥未设置特定对象确定程序的募集机构官方网站、微信朋友圈等互联网媒介；⑦未设置特定对象确定程序的讲座、报告会、分析会；⑧未设置特定对象确定程序的电话、短信和电子邮件等通讯媒介。"
        },
        {
            "title": "（　　）是指基金管理人投资业务人员违反相关法律法规和公司内部规章带来的处罚和损失风险",
            "question": "A. 投资合规性风险\nB. 监管合规性风险\nC. 销售合规性风险\nD. 反洗钱合规性风险",
            "answer": "A",
            "explain": "投资合规性风险是指基金管理人投资业务人员违反相关法律法规和公司内部规章带来的处罚和损失风险。"
        }, {
            "title": "（　　）是识别和分析与实现目标相关的风险，从而为确定应该如何管理风险奠定基础",
            "question": "A. 事项识别\nB. 风险应对\nC. 风险评估\nD. 控制活动",
            "answer": "C",
            "explain": "风险评估是识别和分析与实现目标相关的风险，从而为确定应该如何管理风险奠定基础。"
        },
        {
            "title": "关于基金销售机构的职责规范，下列表述错误的是（　　）",
            "question": "A. I、II\nB. I、II、IV\nC. II、III\nD. IV",
            "questions": "I. 客户身份资料自业务关系结束当年起至少保存15年，与销售业务有关的其他资料自业务发生当年起至少保存15年<br>II. 基金管理人、基金销售机构应当建立健全档案管理制度，妥善保管基金份额持有人的开户资料和与销售业务有关的其他资料<br>III. 销售基金时，基金管理人应制定合理的业务规则，对基金认购、申购、赎回、转换、非交易过户等行为进行规定<br>IV. 基金募集申请获得中国证监会核准前，基金管理人、基金销售机构可以向公众分发、公布基金宣传推介材料",
            "answer": "D",
            "explain": "基金募集申请获得中国证监会核准前，基金管理人、基金销售机构不得办理基金的销售业务，不得向公众分发、公布基金宣传推介材料或发售基金份额。"
        },
        {
            "title": "（　　）和（　　）是现代金融体系的两大运作载体",
            "question": "A. 金融市场；金融经营机构\nB. 金融市场；金融服务机构\nC. 货币资金融通市场；金融市场\nD. 货币资金融通市场；金融服务机构",
            "answer": "B",
            "explain": "金融市场和金融服务机构是现代金融体系的两大运作载体。"
        },
        {
            "title": "基金产品风险评价需要考虑的因素包括（　　）",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、III、IV\nD. I、II、III、IV",
            "questions": "I. 基金招募说明书所明示的投资方向、投资范围和投资比例<br>II. 基金的历史规模和持仓比例<br>III. 基金的过往业绩及基金净值的历史波动程度<br>IV. 基金成立以来有无违规行为发生",
            "answer": "D",
            "explain": "基金产品风险评价应当至少依据以下四个因素：(1)基金招募说明书所明示的投资方向、投资范围和投资比例；(2)基金的历史规模和持仓比例；(3)基金的过往业绩及基金净值的历史波动程度；(4)基金成立以来有无违规行为发生。"
        },
        {
            "title": "风险管理是基金公司经营管理的重要组成部分，下列表述符合风险管理全面性原则要求的是（　　）",
            "question": "A. II、III\nB. II、III、IV\nC. I、II、III、IV\nD. I、II、III",
            "questions": "I. 公司应建立具体的风险控制指标体系<br>II. 风险控制必须覆盖公司的各项业务<br>III. 风险控制必须覆盖公司的各个部门和各个岗位<br>IV. 风险控制渗透到决策、执行、反馈等各个业务环节",
            "answer": "B",
            "explain": "风险管理的全面性原则，即风险管理是公司经营管理的重要组成部分，也是业务运作体系及日常业务流程中不可或缺的因素，风险控制必须覆盖公司的各项业务、各个部门和各个岗位，渗透到决策、执行、反馈等各个业务环节。"
        },
        {
            "title": "下列有关公开披露基金信息的说法，错误的是（　　）",
            "question": "A. 禁止进行虚假记载、误导性陈述或者重大遗漏\nB. 禁止对基金的证券投资业绩进行预测\nC. 禁止违规承诺收益或者承担损失\nD. 可以诋毁其他基金管理人或者基金销售机构",
            "answer": "D",
            "explain": "公开披露基金信息，不得有下列行为：虚假记载、误导性陈述或者重大遗漏；对证券投资业绩进行预测；违规承诺收益或者承担损失；诋毁其他基金管理人、基金托管人或者基金销售机构；法律、行政法规和国务院证券监督管理机构规定禁止的其他行为。"
        },
        {
            "title": "某股票型基金产品共有基金份额3000万份。现有代表2700万份的份额持有人出席份额持有人大会，就更换基金托管人的事项进行表决，至少需要代表（　　）万份基金份额的持有人同意时，此审议事项可通过",
            "question": "A. 2000\nB. 1350\nC. 1500\nD. 1800",
            "answer": "D",
            "explain": "基金份额持有人大会就审议事项做出决定，应当经参加大会的基金份额持有人所持表决权的1/2以上通过；但是，转换基金的运作方式、更换基金管理人或者基金托管人、提前终止基金合同、与其他基金合并，应当经参加大会的基金份额持有人所持表决权的2/3以上通过。因此，至少需要1800万份基金份额的持有人同意时，更换基金托管人这一事项可通过。"
        },
        {
            "title": "下列关于基金账户的说法中，错误的是（　　）",
            "question": "A. 基金账户都由基金管理人为投资者开立\nB. 基金账户用于记录投资者持有的基金份额余额\nC. 基金账户用于记录投资者持有的基金份额变动情况\nD. 投资者进行认购时，如果没有开立基金账户，需要提前开立基金账户",
            "answer": "A",
            "explain": "基金账户是基金登记人为基金投资者开立的、用于记录其持有的基金份额余额和变动情况的账户。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2021/flfg2.js